import React from 'react';
import { Helmet } from 'react-helmet';
import ReactModal from 'react-modal';
import 'styles/react-kanban.css';
import { withToastManager } from 'react-toast-notifications';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment-timezone';
import services from 'services/services';
import service_studies from 'services/studies';
import service_accounts from 'services/accounts';
import service_people from 'services/people';
import UploadParticipants from 'components/Participant/UploadParticipants';
import { getSenderProfileSelection } from 'components/Participant/SendEmailForm';
import config from 'config';
import { withTheme } from 'emotion-theming';
import store from 'store';
import DatePicker from 'react-datepicker';
import DataViz from 'components/DataViz';
import SelectModal from 'components/SelectModal';
import analytics from 'utils/analytics';
import ReactCanvasConfetti from 'react-canvas-confetti';
import ReactTooltip from 'react-tooltip';
import TextAreaAutosize from 'react-textarea-autosize';
import InputSearch from 'components/InputSearch';
const env = process.env.NODE_ENV;
import cloneDeep from 'lodash/cloneDeep';
import BreadcrumbBack, { BreadcrumbTitle } from 'components/BreadcrumbBack';

import {
    FiXCircle,
    FiCalendar,
    FiDollarSign,
    FiSend,
    FiColumns,
    FiSave,
    FiDownloadCloud,
    FiChevronDown,
    FiEdit,
    FiFilter,
    FiMinusCircle,
    FiUserPlus,
    FiPaperclip,
    FiPieChart,
    FiFileMinus,
    FiUploadCloud,
    FiExternalLink,
    FiInfo,
    FiLayers,
    FiMail,
    FiUser
} from 'react-icons/fi';

import StudyFilters from 'components/Study/StudyFilters';
import { MergeTagsDropdown } from 'components/MergeTagsDropdown';
import helpers from 'utils/helpers';
import helpersStudy from 'utils/helpers-study';
import helpersScreener from 'utils/helpers-screener';
import H1 from 'components/H1';
import { Flex, Box, Button } from 'rebass';
import { Label, Input, Select } from '@rebass/forms';
import ParticipantNotes from 'components/Participant/ParticipantNotes';
import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import EmailEditor from 'components/EmailTools/EmailEditor';

import PaymentModal from 'components/PaymentModal';
import { DeleteStudyPeopleModal } from 'components/DeleteStudyPeopleModal';
import StudyParticipantsList from 'components/Study/StudyParticipantsList';
import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import StudyPageSubNav from 'components/Study/StudyPageSubNav';
import NiceDropdown from 'components/NiceDropdown';
import SideOverlay from 'components/SideOverlay';
import NiceModal from 'components/NiceModal';
import UpgradeButton from 'components/UpgradeButton';
import Badge from 'components/Badge';
import { RichIconBackground } from 'components/RichIconBackground';
import {
    SP_STATUS_KEY_TITLE,
    SCREENER_STUDY_ONLY,
    SP_PARTICIPANT_STATUS,
    SP_PARTICIPANT_SESSION,
    SP_PARTICIPANT_LOCATION,
    MAX_EMAIL_ATTACHMENTS_SIZE,
    MOMENT_HUMAN_DATE,
    PAID_FEATURE,
    EMAIL_TEMPLATE_TYPE,
    NOTIFICATION_TITLE_DISABLED_EMAILING,
    NOTIFICATION_TITLE_HTML_NOT_ALLOWED,
    NOTIFICATION_CONTENT_DISABLED_EMAILING,
    NOTIFICATION_CONTENT_HTML_NOT_ALLOWED,
    TABLE_CHECKED_STATUS,
    STUDY_STATUS,
    STUDY_STATUS_DRAFT,
    STUDY_STATUS_ACTIVE,
    STUDY_STATUS_PAUSED,
    STUDY_STATUS_COMPLETE,
    STUDY_STATUS_BADGE_TYPE,
    INTEGRATION_DSCOUT
} from 'utils/constants';
import NotificationCard from 'components/NotificationCard';
import cache from 'utils/cache';
import ShareStudyPeopleModal from 'components/ShareStudyPeopleModal';
import PaymentToastMessage from 'components/PaymentToastMessage';
import { SessionDatepickerModal } from 'components/SessionDatepickerModal';
import DscoutInviteModal from 'components/DscoutInviteModal';
import DscoutIntegration from 'components/DscoutIntegration';
import { EmailCcTokenizer } from 'components/EmailCcTokenizer';
import styles from 'styles/study-page.module.css';
import { withToastHelper } from 'hooks/useToastHelper';
import { ReviewRecipientsModal } from 'components/ReviewRecipientsModal';
import SenderProfileSelect from 'components/SenderProfileSelect';
import {
    ManageColumnsModalConnected,
    buildTableColumns,
    panelPropertiesStorageKey,
    withDropdownTitles
} from 'components/Study/ManageColumns';

const STORE_PREFIX_SEGMENT = 'pfx_study_segment:';
const STORE_PREFIX_CSV_EXPORT_COLUMNS = 'pfx_study_csv_export:';
const STORE_PREFIX_CSV_EXPORT_PANEL_COLUMNS = 'pfx_study_csv_export_panel:';
const STORE_PREFIX_STUDY_COLUMNS_HIDDEN = 'pfx_study_columns_hidden:';
const STORE_PREFIX_STUDY_COLUMNS_ORDER = 'pfx_study_columns_order:';
const STORE_STUDY_PAGINATION_LIMIT = 'pfx_study_pagination_limit';
const DEFAULT_COLUMNS_HIDDEN = [];
const DEFAULT_COLUMNS_ORDER = {};

class StudyPage extends React.Component {
    constructor(props) {
        super(props);

        this.isAnimationEnabled = false;
        this.animationInstance = null;
        this.nextTickAnimation = this.nextTickAnimation.bind(this);
        this.getInstance = this.getInstance.bind(this);

        this.numHeaders = 6;

        let senderSignatureFromEmail = false;
        this.props.auth.user.sender_signatures.forEach(ss => {
            senderSignatureFromEmail = ss.email;
        });

        const cached_export_csv_checkboxes_exclude = this.getCachedCsvExportScreenerColumns();
        const cached_export_csv_custom_columns_include = this.getCachedCsvExportPanelColumns();

        const studyId = this.props.match.params.id;
        const tableColumns_hidden = this.getColumnsHidden();
        const tableColumns_order = this.getColumnsOrder();
        // Panel property subscription lives in its own storage key so
        // "Reset Columns" can clear it without touching the hidden list.
        const persistedPanelPropertyIds = (() => {
            const raw = store.get(panelPropertiesStorageKey(studyId));
            return Array.isArray(raw) ? raw.filter(id => Number.isFinite(Number(id))).map(Number) : [];
        })();

        let pagination_limit = 20;
        let pagination_limit_cached = store.get(this.getPaginationLimitCacheKey());
        if ([20, 50, 100].includes(pagination_limit_cached)) {
            pagination_limit = pagination_limit_cached;
        }
        const study = cache.get(`study.${studyId}`);

        this.state = {
            pushEventChannel: null,
            search_keyword: '',
            showModalSessionDatepicker: false,
            account_users: [],
            bulk_pay_people: [],
            deleteStudyPeopleModal: {
                isOpen: false,
                requiresForce: false,
                isSubmitting: false,
                request: null
            },
            segment: '', // will be set in getStudy()
            study_loading: !study,
            study_people_loading: true,
            study_people_loading_more: false,
            showModalSendCampaign_type: null,
            study_availability_array: [],
            isRecipientsPreviewModalOpen: false,
            study: {
                title: '',
                description: '',
                screener: [],
                people_counts: {},
                screeners: [],
                study_states: [],
                integrations: [],
                ...study
            },
            users_viewing: [],
            checkAllOrVisibleStatus: TABLE_CHECKED_STATUS.NONE, // none, all, or visible, custom_count
            checkAll_custom_count_number: null,
            checkAll_randomize: false,
            study_people: {
                // with pagination
                data: []
            },
            p_checked: [],
            shareStudyPeopleTitle: this.generateShareStudyPeopleTitle(),
            study_states: [],
            shareStudyPeopleFilterObject: null,
            sender_profiles: [],
            panels: [],
            showModalBulkEditSp: false,
            showModalParticipantImport: false,
            showModalStudyParticipant: false,
            showModalSendCampaign: false,
            showModalDataViz: false,
            showModalDscoutMissions: false,
            datavizScreenerId: null,
            email_attachments: [],
            email_attachment_isUploading: false,
            selectedStudyPerson: {},
            showModalSendCampaign_editMode: false,
            sendCampaign: {
                study_state_id: null,
                subject: '',
                content: '',
                templateType: EMAIL_TEMPLATE_TYPE.BLOCKS,
                from_email: senderSignatureFromEmail || '',
                from_name: this.props.auth.user.name,
                sender_profile_id: null,
                study_people: [],
                study_states: [],
                screener_id: null,
                send_when: null
            },
            recipientsCc: [],
            emailCampaignPreview: null,
            emailCampaignPreview_loading: true,
            foundNewStudyState: false, // this just prevents folks from playing around with old study types
            panel_columns: [],
            showModalExportCsv: false,
            showModalAssignUser: false,
            showModalEmailCampaignSuccess: false,
            showModalEmailCampaignSuccess_showlink: false,
            showModalEmailCampaignSuccess_scheduled: false,
            showModalEmailCampaignSuccess_message: null,
            export_csv_checkboxes_exclude: cached_export_csv_checkboxes_exclude
                ? cached_export_csv_checkboxes_exclude
                : {},
            export_csv_custom_columns_include: cached_export_csv_custom_columns_include
                ? cached_export_csv_custom_columns_include
                : {},
            screenerFilters: [],
            sort: {},
            pagination_limit: pagination_limit,
            showScreenerFilters: false,
            bulkPayVariables: {
                type: '',
                amount: ''
            },
            bulk_edit_field: {},
            bulk_edit_value: null,
            isSendingCampaign: false,
            isSendingSmsCampaign: false,
            tableColumns: [],
            tableColumns_hidden: tableColumns_hidden,
            tableColumns_order: tableColumns_order,
            // Flat column list for the dropdown + table. Rebuilt via
            // `rebuildTableColumns` whenever any input (study, panel
            // columns, hidden list, panel property ids) changes.
            tableColumns_all: buildTableColumns({
                study,
                panelColumns: null,
                tableColumnsHidden: tableColumns_hidden,
                panelPropertyIds: persistedPanelPropertyIds
            }),
            panelPropertyIds: persistedPanelPropertyIds,
            showModalManageColumns: false,
            spot: ''
        };

        this.handleSPLockChange = this.handleSPLockChange.bind(this);
        this.onBulkPayConfirm = this.onBulkPayConfirm.bind(this);
        this.getSegmentDefault = this.getSegmentDefault.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.onTabDelete = this.onTabDelete.bind(this);
        this.handleCheckAllDropdownChange = this.handleCheckAllDropdownChange.bind(this);
        this.getSenderProfilesXHR = this.getSenderProfilesXHR.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.clickSendEmail = this.clickSendEmail.bind(this);
        this.loadMoreStudyPeople = this.loadMoreStudyPeople.bind(this);
        this.deselectAll = this.deselectAll.bind(this);
        this.setSegment = this.setSegment.bind(this);
        this.getStudy = this.getStudy.bind(this);
        this.onBoardColumnNew = this.onBoardColumnNew.bind(this);
        this.performMassActionMove = this.performMassActionMove.bind(this);
        this.handleCloseModalSMSMessage = this.handleCloseModalSMSMessage.bind(this);
        this.resetTableColumns = this.resetTableColumns.bind(this);
        this.handleDisplayedTableColumns = this.handleDisplayedTableColumns.bind(this);
        this.rebuildTableColumns = this.rebuildTableColumns.bind(this);
        this.handleOpenModalManageColumns = this.handleOpenModalManageColumns.bind(this);
        this.handleCloseModalManageColumns = this.handleCloseModalManageColumns.bind(this);
        this.handleManageColumnsSaved = this.handleManageColumnsSaved.bind(this);
        this.emailAttachmentUploadButton = this.emailAttachmentUploadButton.bind(this);
        this.onChangePaginationLimit = this.onChangePaginationLimit.bind(this);
        this.modalParticipantNotesCallbackFunction = this.modalParticipantNotesCallbackFunction.bind(this);
        this.handleCloseModalSendCampaign = this.handleCloseModalSendCampaign.bind(this);
        this.handleOpenModalSendCampaign = this.handleOpenModalSendCampaign.bind(this);
        this.handleModalSendCampaign_review = this.handleModalSendCampaign_review.bind(this);
        this.handleModalSendCampaign_stateUpdate = this.handleModalSendCampaign_stateUpdate.bind(this);
        this.handleOpenModalParticipantImport = this.handleOpenModalParticipantImport.bind(this);
        this.handleCloseModalParticipantImport = this.handleCloseModalParticipantImport.bind(this);
        this.handleOpenModalStudyParticipant = this.handleOpenModalStudyParticipant.bind(this);
        this.handleCloseModalStudyParticipant = this.handleCloseModalStudyParticipant.bind(this);
        this.bulkDownloadFiles = this.bulkDownloadFiles.bind(this);
        this.renderBulkDownload = this.renderBulkDownload.bind(this);
        this.onUpdatePanels = this.onUpdatePanels.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.renderEmailCampaignPreview = this.renderEmailCampaignPreview.bind(this);
        this.onChangeEditor = this.onChangeEditor.bind(this);
        this.onSearchKeywordChange = this.onSearchKeywordChange.bind(this);
        this.onBulkEditParticipantStatusValueChange = this.onBulkEditParticipantStatusValueChange.bind(this);
        this.onProcessBulkEdit = this.onProcessBulkEdit.bind(this);
        this.renderBulkEditValueChanger = this.renderBulkEditValueChanger.bind(this);
        this.customAttributeChanged = this.customAttributeChanged.bind(this);
        this.onStudyStatusChange = this.onStudyStatusChange.bind(this);
    }

    getIsColShowing(tableColumns_hidden, col_id) {
        if (tableColumns_hidden && tableColumns_hidden.includes(col_id)) {
            return false;
        } else {
            return true;
        }
    }

    setColumnsShowHide(columnId, isChecked) {
        let { tableColumns_hidden } = this.state;

        // not checked, that means hide the column; that means add to array
        if (isChecked == false) {
            tableColumns_hidden.push(columnId);
        } else {
            const indexOf_columnId = tableColumns_hidden.indexOf(columnId);
            if (indexOf_columnId != -1) {
                tableColumns_hidden.splice(indexOf_columnId, 1);
            }
        }
        this.saveColumnsShowHide(tableColumns_hidden);
    }

    saveColumnsShowHide(tableColumns_hidden) {
        const study_id = this.props.match.params.id;
        store.set(STORE_PREFIX_STUDY_COLUMNS_HIDDEN + study_id, tableColumns_hidden);
        this.setState({ tableColumns_hidden });
    }

    getColumnsHidden() {
        const study_id = this.props.match.params.id;
        let cols_show_hide = store.get(STORE_PREFIX_STUDY_COLUMNS_HIDDEN + study_id);

        if (!cols_show_hide || !Array.isArray(cols_show_hide)) {
            cols_show_hide = DEFAULT_COLUMNS_HIDDEN;
        }

        return cols_show_hide;
    }

    getColumnsOrder() {
        const study_id = this.props.match.params.id;
        let cols_order = store.get(STORE_PREFIX_STUDY_COLUMNS_ORDER + study_id);

        if (!cols_order) {
            cols_order = DEFAULT_COLUMNS_ORDER;
        }

        return cols_order;
    }

    saveColumnsOrder(cols_order) {
        const study_id = this.props.match.params.id;
        store.set(STORE_PREFIX_STUDY_COLUMNS_ORDER + study_id, cols_order);
        this.setState({ tableColumns_order: cols_order });
    }

    checkIfAnyoneChecked() {
        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one person');
            return;
        } else {
            return true;
        }
    }

    onTabChange(e, study_state) {
        console.log(study_state.title);
        if (e.target.name == 'tab_title') {
            study_state.title = e.target.value;
        } else if (e.target.name == 'tab_order') {
            study_state.order = e.target.value;
        }

        const { study } = this.state;
        const found_ss = study.study_states.find(ss => ss.id == study_state.id);
        const index = study.study_states.indexOf(found_ss);
        if (index > -1) {
            study.study_states[index] = study_state;
            this.setState({ study }, () => {
                this.updateStudyState(study_state.id);
            });
        }
    }

    onTabDelete(study_state_id) {
        const { toastManager } = this.props;
        const that = this;

        const study_state = this.state.study.study_states.find(ss => ss.id == study_state_id);
        if (study_state) {
            console.log(study_state);

            if (confirm(`Are you sure you want to delete "${study_state.title}"?`)) {
                const { study } = this.state;
                const found_ss = study.study_states.find(ss => ss.id == study_state.id);
                const index = study.study_states.indexOf(found_ss);
                if (index > -1) {
                    study.study_states.splice(index, 1);
                    this.setState({ study });
                }

                services
                    .deleteStudyState(study_state.study_id, study_state)
                    .then(() => {
                        const segment_id_all = that.getSegmentDefault(this.state.study);
                        that.setSegment(segment_id_all);

                        toastManager.add('Successfully deleted', {
                            appearance: 'success',
                            autoDismiss: true
                        });
                    })
                    .catch(error => {
                        const errorText = services.parseAndTrackXhrErrors(error);
                        toastManager.add(errorText, {
                            appearance: 'error',
                            autoDismiss: true
                        });
                    });
                console.log('deleting');
            } else {
                console.log('NOT deleting');
            }
        }
    }

    onSearchKeywordChange(e) {
        console.log(e);
        const that = this;
        this.setState({ search_keyword: e.target.value }, () => {
            // Invalidate any prior "select all / custom count" selection — the search
            // keyword is part of the server-side recipient resolution (see /people-campaign
            // route), so leaving the selection sticky would let the user submit a campaign
            // whose resolved population no longer matches the count they saw (PFOX-1284).
            this.deselectAll();

            if (that.onSearchKeywordChange_delay) {
                clearTimeout(that.onSearchKeywordChange_delay);
            }

            that.onSearchKeywordChange_delay = setTimeout(() => {
                that.getStudyPeople(that.state.segment, 1);
            }, 500);
        });
    }

    onChangeEditor(editorData, editorType) {
        const { sendCampaign } = this.state;
        sendCampaign.content = editorData;
        sendCampaign.templateType = editorType;
        this.setState({ sendCampaign });
    }

    /**
     * Update email data with new body and subject when user selects a template
     *
     * @param {{ body: any; subject: string; type: number; id: number }} template
     */
    onTemplate(template) {
        this.setState(({ sendCampaign }) => {
            sendCampaign.content = template.body;
            sendCampaign.subject = template.subject;
            sendCampaign.templateType = template.type;
            return { sendCampaign };
        });
    }

    handleOpenModalParticipantImport() {
        this.setState({ showModalParticipantImport: true });
    }

    handleCloseModalParticipantImport() {
        this.setState({ showModalParticipantImport: false });
    }

    handleCardClick(study_person_id) {
        analytics.track('study-sp-click', { study_id: this.state.study.id });
        const { toastManager } = this.props;
        // load the modal so user gets instant response
        this.handleOpenModalStudyParticipant(study_person_id);
        const lock_action = 'lock';
        service_studies
            .getStudyPerson(this.state.study.id, study_person_id, lock_action)
            .then(selectedStudyPerson => {
                if (selectedStudyPerson) {
                    this.setState({ selectedStudyPerson });
                    this.updateStudyPersonInGrid(selectedStudyPerson);
                }
            })
            .catch(error => {
                this.handleCloseModalStudyParticipant();

                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    handleOpenModalSendCampaign(automation_type, studyPeople_checked, options) {
        const { sendCampaign } = this.state;
        sendCampaign.study_people = studyPeople_checked;
        sendCampaign.study_states = null;
        if (automation_type == 'screen') {
            if (options.screener_id) {
                // find screener
                const screenerFound = this.state.study.screeners.find(s => s.id == options.screener_id);
                if (screenerFound) {
                    sendCampaign.screener_id = options.screener_id;
                    sendCampaign.subject = screenerFound.email_screener_subject;
                    sendCampaign.content = screenerFound.email_screener_body;
                    sendCampaign.templateType = screenerFound.email_screener_type;
                } else {
                    alert('Screener not found - please try again.');
                    return;
                }
            } else {
                sendCampaign.subject = this.state.study.email_screener_subject;
                sendCampaign.content = this.state.study.email_screener_body;
                sendCampaign.templateType = this.state.study.email_screener_type;
            }
        } else if (automation_type == 'schedule') {
            sendCampaign.subject = this.state.study.email_scheduling_subject;
            sendCampaign.content = this.state.study.email_scheduling_body;
            sendCampaign.templateType = this.state.study.email_scheduling_type;
        } else if (automation_type == 'confirmation') {
            sendCampaign.subject = this.state.study.email_confirmation_subject;
            sendCampaign.content = this.state.study.email_confirmation_body;
            sendCampaign.templateType = this.state.study.email_confirmation_type;
        } else if (automation_type == 'custom') {
            sendCampaign.subject = '';
            sendCampaign.content = '';
            sendCampaign.templateType = EMAIL_TEMPLATE_TYPE.BLOCKS;
        } else if (automation_type == 'dscout') {
            sendCampaign.subject = options.subject ? options.subject : '';
            sendCampaign.content = options.content ? options.content : '';
            sendCampaign.templateType = options.templateType ? options.templateType : EMAIL_TEMPLATE_TYPE.BLOCKS;
            sendCampaign.study_integration_id = options.study_integration_id;
        }

        // clear the screener_id if not needed
        if (['dscout', 'custom', 'schedule', 'confirmation'].includes(automation_type)) {
            sendCampaign.screener_id = null;
        }

        this.setState({
            showModalSendCampaign: true,
            showModalSendCampaign_type: automation_type,
            sendCampaign,
            showModalSendCampaign_editMode: ['dscout', 'custom'].includes(automation_type) ? true : false
        });

        const studyAutomationOnboardingTask = `study-automation-${this.state.study.id}`;
        if (!helpers.isOnboardingTaskComplete(this.props.auth.user, studyAutomationOnboardingTask)) {
            services.completeOnboardingTask(studyAutomationOnboardingTask);
        }
    }

    isEmailingFeatureDisabled() {
        return !helpers.hasFeatureEnabled(this.props.auth.account, PAID_FEATURE.EMAILING);
    }

    isEmailSendingDisabled() {
        return (
            this.isEmailingFeatureDisabled() ||
            (this.state.sendCampaign.templateType == EMAIL_TEMPLATE_TYPE.HTML &&
                !helpers.hasVerifiedDomain(this.props.auth.account))
        );
    }

    isDscoutIntegrationDisabled() {
        return !helpers.hasFeatureEnabled(this.props.auth.account, PAID_FEATURE.DSCOUT_INTEGRATION);
    }

    getDscoutIntegration() {
        const { integrations } = this.state.study;

        if (!integrations?.length) return null;

        return integrations.find(integration => integration.integration_id === INTEGRATION_DSCOUT) || null;
    }

    // @todo this is what should move the cards, and refresh the page
    handleCloseModalSendCampaign(move_sp_back) {
        const { study_states } = this.state;
        this.setState({ showModalSendCampaign: false, recipientsCc: [] });

        const next_study_state_id = this.state.sendCampaign.study_state_id;

        // move back == dont move anything :D
        if (move_sp_back) {
            // new study state should be "study_state_id_previous"
            // @todo only for manual moves?
        }
        // move it to the next column
        else {
            // move cards
            // @todo-move

            try {
                this.performMassActionMove(next_study_state_id);
            } catch (e) {
                helpers.trackError(e);
            }
        }
    }

    // TODO: here is important
    handleModalSendCampaign_stateUpdate(key, val) {
        const that = this;
        const { sendCampaign } = this.state;
        sendCampaign[key] = val;
        this.setState({ sendCampaign }, () => {
            // don't do this every keyup
            if (that.handleModalSendCampaign_stateUpdate_TIMEOUT) {
                clearTimeout(that.handleModalSendCampaign_stateUpdate_TIMEOUT);
            }
            that.handleModalSendCampaign_stateUpdate_TIMEOUT = setTimeout(function() {
                const email_action = 'preview';
                that.handleModalSendCampaign_review(email_action);
            }, 1000);
        });
    }

    handleModalSendCampaign_review(emailAction) {
        if ((emailAction === 'send' || emailAction === 'test') && this.state.study_people_loading) {
            this.notifyPeopleStillLoading();
            return;
        }

        let test_email_address = null;
        if (emailAction == 'preview') {
            this.setState({ emailCampaignPreview_loading: true });
        } else if (emailAction == 'test') {
            test_email_address = prompt('Email to send test to:', this.props.auth.user.email);

            if (!test_email_address) {
                return;
            }
        } else if (emailAction == 'send') {
            if (!confirm('Are you sure you want to send this email?')) {
                return false;
            } else {
                this.setState({ isSendingCampaign: true });
            }
        } else {
            alert(`We did not get a email_action. Please email ${config.SUPPORT_EMAIL}`);
            return;
        }

        let people = [];
        let filters = null;
        let search_keyword = null;
        let custom_count_number = null;
        const { toastManager } = this.props;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        /*

            **** REMINDER ****


            consider editing the mass sms method as well


            **** REMINDER ****

            */

        services
            .sendEmailCampaign(
                this.state.study.id,
                people, // be careful, this sends a Person model, not Study Person :)
                this.state.sendCampaign.study_states,
                filters,
                this.state.sendCampaign.subject,
                this.state.sendCampaign.content,
                this.state.sendCampaign.templateType,
                emailAction,
                this.state.sendCampaign.from_email,
                this.state.sendCampaign.from_name,
                test_email_address,
                this.state.sendCampaign.screener_id,
                search_keyword,
                custom_count_number,
                this.state.sendCampaign.send_when,
                JSON.stringify(this.state.sort),
                this.state.email_attachments,
                this.state.checkAll_randomize,
                this.state.sendCampaign.study_integration_id,
                this.state.recipientsCc
            )
            .then(emailCampaignResponse => {
                this.setState({ isSendingCampaign: false });

                if (emailAction == 'preview') {
                    this.setState({
                        emailCampaignPreview: emailCampaignResponse,
                        emailCampaignPreview_loading: false
                    });
                } else if (emailAction == 'test') {
                    toastManager.add('Test email successfully sent', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                } else {
                    const wasScheduled = !!this.state.sendCampaign.send_when;
                    const success_msg = wasScheduled ? 'Email successfully scheduled' : 'Email successfully sent';

                    toastManager.add(success_msg, {
                        appearance: 'success',
                        autoDismiss: true
                    });

                    this.getStudy();
                    this.deselectAll();

                    let { sendCampaign } = this.state;
                    sendCampaign.send_when = null;

                    this.setState({
                        showModalSendCampaign: false,
                        showModalScheduleSend: false,
                        showModalEmailCampaignSuccess: true,
                        showModalEmailCampaignSuccess_scheduled: wasScheduled,
                        showModalEmailCampaignSuccess_showlink: false,
                        showModalEmailCampaignSuccess_message: null,
                        sendCampaign
                    });

                    if (this.state.sendCampaign.screener_id) {
                        const found_screener = this.state.study.screeners.find(
                            s => s.id == this.state.sendCampaign.screener_id
                        );
                        console.log('found_screener', found_screener);
                        let found_screener_message = '';
                        if (found_screener) {
                            if (found_screener.participant_external == SCREENER_STUDY_ONLY) {
                                found_screener_message = (
                                    <Box mb={3} className="warning-box">
                                        The e-mailed screener is <strong>limited to Study Participants</strong>, please
                                        update Screener Settings to allow anyone to complete it.
                                    </Box>
                                );
                            }
                        }

                        const success_message = (
                            <Box mt={2}>
                                {found_screener_message}

                                <Box mt={3} fontSize={1}>
                                    Share on social media,
                                </Box>
                                <Box fontSize={1} className="ellipsis">
                                    <a
                                        href={`${config.getAccountPrefixUrl(this.props.auth.account)}/emails/${
                                            emailCampaignResponse.data.email_campaign_uuid
                                        }`}
                                        target="_blank"
                                    >
                                        {config.getAccountPrefixUrl(this.props.auth.account)}/emails/
                                        {emailCampaignResponse.data.email_campaign_uuid}
                                    </a>
                                </Box>
                            </Box>
                        );

                        this.setState({
                            showModalEmailCampaignSuccess: true,
                            // Used to be `success_message` to surface the "Get e-mail link" share block in
                            // the success modal; kept null so that block no longer renders.
                            // showModalEmailCampaignSuccess_message: success_message,
                            showModalEmailCampaignSuccess_message: null,
                            recipientsCc: []
                        });

                        const count_recipients = this.getNumberPeopleSelected();
                        if (count_recipients >= 100) {
                            let animation_duration = 3;
                            if (count_recipients >= 5000) {
                                animation_duration = 9;
                            } else if (count_recipients >= 1000) {
                                animation_duration = 6;
                            }

                            this.runCelebration(animation_duration);
                        }
                    }
                }
            })
            .catch(error => {
                this.setState({ isSendingCampaign: false });
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: false
                });
            });
    }

    handleCloseModalSMSMessage() {
        this.setState({ showModalSMSMessage: false });
    }

    handleModalSendSms(action) {
        if ((action == 'send' || action == 'test') && this.state.study_people_loading) {
            this.notifyPeopleStillLoading();
            return;
        }

        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        const content = this.state.smsCampaign_content.trim();
        if (!content.length) {
            alert('Message body can not be empty');
            return;
        }

        let test_phone_number = null;
        if (action == 'test') {
            test_phone_number = prompt('Phone number to send test to:', this.props.auth.user.phone_number);

            if (!test_phone_number) {
                return;
            }
        } else if (action == 'send') {
            if (!confirm('Are you sure you want to send this SMS?')) {
                return false;
            } else {
                this.setState({ isSendingSmsCampaign: true });
            }
        } else {
            alert(`We did not get a action. Please email ${config.SUPPORT_EMAIL}`);
            return;
        }

        let people = [];
        let filters = null;
        let search_keyword = null;
        let custom_count_number = null;
        const { toastManager } = this.props;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        /*

            **** REMINDER ****


            consider editing the mass email method as well


            **** REMINDER ****

            */

        service_studies
            .sendSmsCampaign(
                this.state.study.id,
                people, // be careful, this sends a Person model, not Study Person :)
                this.state.sendCampaign.study_states,
                filters,
                content,
                action,
                test_phone_number,
                search_keyword,
                custom_count_number,
                JSON.stringify(this.state.sort),
                this.state.checkAll_randomize
            )
            .then(() => {
                this.setState({ isSendingSmsCampaign: false });

                if (action == 'test') {
                    toastManager.add('Test email successfully sent', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                } else {
                    const success_msg = 'SMS successfully sent';

                    toastManager.add(success_msg, {
                        appearance: 'success',
                        autoDismiss: true
                    });

                    this.getStudy();
                    this.deselectAll();

                    this.handleCloseModalSMSMessage();
                }
            })
            .catch(error => {
                this.setState({ isSendingSmsCampaign: false });
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: false
                });
            });
    }

    handleRemoveScreenerResponse(screener) {
        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        let people = [];
        let filters = null;
        let search_keyword = null;
        const { toastManager } = this.props;
        let custom_count_number = null;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        if (!confirm(`Are you sure you want to delete these screener responses?`)) {
            return;
        }

        toastManager.add('Starting to remove screener responses', {
            appearance: 'success',
            autoDismiss: true
        });

        service_studies
            .studyRemoveStudyPeopleScreenerResponse(
                this.state.study.id,
                people, // be careful, this sends a Person model, not Study Person :)
                filters,
                search_keyword,
                JSON.stringify(this.state.sort),
                custom_count_number,
                this.state.checkAll_randomize,
                screener.id
            )
            .then(() => {
                toastManager.add('Successfully removed screener responses', {
                    appearance: 'success',
                    autoDismiss: true
                });
                this.deselectAll();
                this.getStudy();
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }
    handleRemoveStudyPeople() {
        if (this.state.study_people_loading) {
            this.notifyPeopleStillLoading();
            return;
        }

        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        const request = {
            people: [],
            filters: null,
            search_keyword: null,
            custom_count_number: null,
            sort: JSON.stringify(this.state.sort),
            randomize: this.state.checkAll_randomize,
            // Use the canonical per-scope count so ALL / CUSTOM selections show the real
            // target in the modal — `p_checked` is empty in those scopes.
            participantCount: this.getNumberPeopleSelected()
        };

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            request.filters = this.state.screenerFilters;
            request.search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            request.filters = this.state.screenerFilters;
            request.search_keyword = this.state.search_keyword;
            request.custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            request.people = this.state.p_checked;
        }

        this.setState({
            deleteStudyPeopleModal: {
                isOpen: true,
                requiresForce: false,
                isSubmitting: false,
                request
            }
        });
    }

    confirmRemoveStudyPeople = ({ force }) => {
        const { toastManager } = this.props;
        const { request } = this.state.deleteStudyPeopleModal;
        if (!request) return;

        this.setState(prev => ({
            deleteStudyPeopleModal: { ...prev.deleteStudyPeopleModal, isSubmitting: true }
        }));

        toastManager.add('Starting to remove participants', {
            appearance: 'success',
            autoDismiss: true
        });

        service_studies
            .studyRemoveStudyPeople(
                this.state.study.id,
                request.people, // be careful, this sends a Person model, not Study Person :)
                request.filters,
                request.search_keyword,
                request.sort,
                request.custom_count_number,
                request.randomize,
                { force }
            )
            .then(() => {
                toastManager.add('Successfully removed participants', {
                    appearance: 'success',
                    autoDismiss: true
                });
                this.setState({
                    deleteStudyPeopleModal: {
                        isOpen: false,
                        requiresForce: false,
                        isSubmitting: false,
                        request: null
                    }
                });
                this.deselectAll();
                this.getStudy();
            })
            .catch(error => {
                const errorCode = error.response && error.response.data && error.response.data.error_code;

                if (errorCode === 'scheduled_or_paid_participants' && !force) {
                    // Re-open the modal in force mode so the user can choose to override.
                    this.setState(prev => ({
                        deleteStudyPeopleModal: {
                            ...prev.deleteStudyPeopleModal,
                            requiresForce: true,
                            isSubmitting: false
                        }
                    }));
                    return;
                }

                toastManager.add(services.parseAndTrackXhrErrors(error), {
                    appearance: 'error',
                    autoDismiss: true
                });
                this.setState(prev => ({
                    deleteStudyPeopleModal: { ...prev.deleteStudyPeopleModal, isSubmitting: false }
                }));
            });
    };

    closeRemoveStudyPeopleModal = () => {
        this.setState({
            deleteStudyPeopleModal: {
                isOpen: false,
                requiresForce: false,
                isSubmitting: false,
                request: null
            }
        });
    };

    async onBulkPayConfirm({ amount, paymentType, paymentDate }) {
        const { toastManager } = this.props;

        const peopleIds = this.state.bulk_pay_people.map(p => p.id);

        try {
            await service_studies.bulkPayAccept(this.state.study.id, peopleIds, paymentType, amount, paymentDate);

            toastManager.add('Payment process initiated', {
                appearance: 'success',
                autoDismiss: true
            });

            this.setState({
                bulk_pay_people: [],
                showModalBulkPay: false
            });

            this.deselectAll();
            this.getStudyPeople(this.state.segment);
        } catch (error) {
            const errorText = services.parseAndTrackXhrErrors(error);
            const studyPersonId = error.response && error.response.data && error.response.data.study_person_id;
            toastManager.add(
                <PaymentToastMessage studyId={this.state.study.id} message={errorText} studyPersonId={studyPersonId} />,
                {
                    appearance: 'error',
                    autoDismiss: false
                }
            );
        }
    }

    /**
     * Generate the title for the share study people modal
     *
     * @param {number} count Number of people selected
     */
    generateShareStudyPeopleTitle(count = 0) {
        const formattedCount = helpers.numberFormat(count);

        if (count === 0) return 'Put panelists in study';

        if (count === 1) return 'Put 1 panelist in study';

        return `Put ${formattedCount} panelists in study`;
    }

    openShareStudyPeopleModal() {
        if (!this.state.p_checked.length) {
            return this.props.toastManager.add('Please "checkbox" at least one study participant', {
                appearance: 'info',
                autoDismiss: true
            });
        }

        const count = this.getNumberPeopleSelected();
        const shareStudyPeopleTitle = this.generateShareStudyPeopleTitle(+count);

        this.setState({ shareStudyPeopleFilterObject: this.createFilterQuery(), shareStudyPeopleTitle });
    }

    bulkPayXHR() {
        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        let people = [];
        let filters = null;
        let search_keyword = null;
        const { toastManager } = this.props;
        let custom_count_number = null;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        service_studies
            .bulkPayVerify(
                this.state.study.id,
                people, // be careful, this sends a Person model, not Study Person :)
                filters,
                search_keyword,
                JSON.stringify(this.state.sort),
                custom_count_number,
                this.state.checkAll_randomize
            )
            .then(people => {
                this.setState({
                    bulk_pay_people: people,
                    showModalBulkPay: true
                });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
                const studyPersonId = error.response && error.response.data && error.response.data.study_person_id;
                toastManager.add(
                    <PaymentToastMessage
                        studyId={this.state.study.id}
                        message={errorText}
                        studyPersonId={studyPersonId}
                    />,
                    {
                        appearance: 'error',
                        autoDismiss: false
                    }
                );
            });
    }

    handleOpenModalStudyParticipant(study_person_id) {
        console.log('handleOpenModalStudyParticipant');
        window.history.pushState(
            null,
            null,
            `${config.UI_SUFFIX}/studies/${this.state.study.id}/participants/${study_person_id}`
        ); // not passing a title or URL
        this.setState({ showModalStudyParticipant: true });
    }

    handleCloseModalStudyParticipant() {
        const { toastManager } = this.props;

        // un-lock the SP
        const lock_action = 'unlock';
        service_studies
            .getStudyPerson(this.state.study.id, this.state.selectedStudyPerson.id, lock_action)
            .then(study_person => {
                if (study_person) {
                    this.updateStudyPersonInGrid(study_person);
                }
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });

        window.history.pushState(null, null, `${config.UI_SUFFIX}/studies/${this.state.study.id}`); // not passing a title or URL
        this.setState({ showModalStudyParticipant: false, selectedStudyPerson: {} });
    }

    xhrMoveStudyPeople(study_people, study_states, new_study_state_id, cb) {
        const { toastManager } = this.props;

        service_studies
            .studyMoveStudyPeople(this.state.study.id, study_people, study_states, new_study_state_id)
            .then(() => {
                toastManager.add('Successfuly moved people', {
                    appearance: 'success',
                    autoDismiss: true
                });
                cb();
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getCachedSegmentChoice() {
        const study_id = this.props.match.params.id;
        return store.get(STORE_PREFIX_SEGMENT + study_id);
    }

    setCachedSegmentChoice(segment_id) {
        const study_id = this.props.match.params.id;
        return store.set(STORE_PREFIX_SEGMENT + study_id, segment_id);
    }

    getCachedCsvExportScreenerColumns() {
        const study_id = this.props.match.params.id;
        return store.get(STORE_PREFIX_CSV_EXPORT_COLUMNS + study_id);
    }

    setCachedCsvExportScreenerColumns(data) {
        const study_id = this.props.match.params.id;
        return store.set(STORE_PREFIX_CSV_EXPORT_COLUMNS + study_id, data);
    }

    getCachedCsvExportPanelColumns() {
        const study_id = this.props.match.params.id;
        return store.get(STORE_PREFIX_CSV_EXPORT_PANEL_COLUMNS + study_id);
    }

    setCachedCsvExportPanelColumns(data) {
        const study_id = this.props.match.params.id;
        return store.set(STORE_PREFIX_CSV_EXPORT_PANEL_COLUMNS + study_id, data);
    }

    getSegmentDefault(study) {
        let segment = null;
        const segment_all = study.study_states.find(ss => ss.title == 'All');

        if (segment_all) {
            segment = segment_all.id;
        } else {
            segment = study.study_states[0].id;
        }

        return segment;
    }

    getStudy(dontGetNewStudyPeople) {
        const { toastManager } = this.props;

        this.setState({ study_loading: true });

        if (!dontGetNewStudyPeople) {
            this.setState({ study_people_loading: true });
        }

        const studyId = this.props.match.params.id;
        services
            .getStudy(studyId)
            .then(study => {
                const that = this;
                cache.set(`study.${studyId}`, study);

                console.log('users viewing', study.users_viewing);

                this.setState(
                    {
                        study,
                        study_loading: false,
                        users_viewing: study.users_viewing
                    },
                    () => {
                        const url_study_person_id = this.props.match.params.study_person_id;
                        if (url_study_person_id > 0) {
                            this.handleCardClick(url_study_person_id);
                        }

                        this.getAvailabilityXHR();
                        // Rebuild inside the callback so state from the
                        // setState above has flushed before we read it.
                        this.rebuildTableColumns({ study });
                    }
                );

                let segment = null;
                if (!this.state.segment) {
                    // look for cached segment
                    const cached_segment_id = this.getCachedSegmentChoice();
                    if (cached_segment_id) {
                        // verify its found
                        const cached_segment_found = study.study_states.find(ss => ss.id == cached_segment_id);
                        if (cached_segment_found) {
                            segment = cached_segment_id;
                        }
                    }

                    // if no cached segment found, get the default
                    if (!segment) {
                        segment = this.getSegmentDefault(study);
                    }

                    this.setState({ segment });
                } else {
                    segment = this.state.segment;
                }

                let { bulkPayVariables } = this.state;
                bulkPayVariables.amount = study.incentive;
                this.setState({ bulkPayVariables });

                if (dontGetNewStudyPeople) {
                    // just ignore :)
                } else {
                    // this also gets study people
                    this.setSegment(segment);
                }

                // return;
                // check if study is old, and doesn't have any automation
                let foundNewStudyState = false;
                const studyStateIds = [];
                study.study_states.forEach(ss => {
                    if (ss.type == 'screen') {
                        foundNewStudyState = true;
                    }
                });
                this.setState({ foundNewStudyState });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getPaginationLimitCacheKey() {
        return `${STORE_STUDY_PAGINATION_LIMIT}:${this.props.match.params.id}`;
    }

    onChangePaginationLimit(new_limit) {
        let set_limit = 20;
        new_limit = parseInt(new_limit);
        if ([20, 50, 100].includes(new_limit)) {
            set_limit = new_limit;
        }
        store.set(this.getPaginationLimitCacheKey(), set_limit);
        this.setState({ pagination_limit: set_limit }, () => {
            this.getStudyPeople(this.state.segment, 1);
        });
    }

    loadMoreStudyPeople() {
        this.setState({ study_people_loading_more: true });
        const next_page = this.state.study_people.current_page + 1;
        this.getStudyPeople(this.state.segment, next_page);
    }

    getStudyPeople(segment, page, export_csv) {
        const { toastManager, toastHelper } = this.props;
        const that = this;

        let request_options = {
            study_id: this.props.match.params.id,
            segment,
            page,
            search_keyword: this.state.search_keyword,
            filters: this.state.screenerFilters, //FILTERS ARE PASSED IN AS JSON, NOT A STRING
            export_csv,
            sort: JSON.stringify(this.state.sort),
            pagination_limit: this.state.pagination_limit
        };

        if (export_csv) {
            // checked people.. if set
            let people_ids = [];
            let people;
            let custom_count_number = '';

            // see which "questions" the user selected
            const query_checkboxes_exclude = [];
            const export_csv_checkboxes_exclude = document.getElementsByName('export_csv_checkboxes_exclude');
            for (let i = 0, n = export_csv_checkboxes_exclude.length; i < n; i++) {
                if (!export_csv_checkboxes_exclude[i].checked) {
                    if (export_csv_checkboxes_exclude[i].dataset.question_field_name) {
                        query_checkboxes_exclude.push(export_csv_checkboxes_exclude[i].dataset.question_field_name);
                    }
                }
            }

            const query_checkboxes_custom_columns_include = [];
            const export_csv_custom_columns_include = document.getElementsByName('export_csv_custom_columns_include');
            for (let i = 0, n = export_csv_custom_columns_include.length; i < n; i++) {
                if (export_csv_custom_columns_include[i].checked) {
                    if (export_csv_custom_columns_include[i].dataset.custom_column_id) {
                        query_checkboxes_custom_columns_include.push(
                            export_csv_custom_columns_include[i].dataset.custom_column_id
                        );
                    }
                }
            }

            // see if checkboxes are checked
            if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
                // skip b/c this is ALL
            } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
                // only set the custom count
                custom_count_number = this.state.checkAll_custom_count_number;
            } else {
                people = this.state.p_checked;
                people.forEach(p => {
                    people_ids.push(p.id);
                });
            }

            request_options.csv_fields_exclude = JSON.stringify(query_checkboxes_exclude);
            request_options.csv_panel_fields_include = JSON.stringify(query_checkboxes_custom_columns_include);
            request_options.people_ids = people_ids;
            request_options.custom_count_number = custom_count_number;
            request_options.randomize = this.state.checkAll_randomize ? 1 : 0;

            service_studies
                .getStudyPeoplePOST(request_options)
                .then(() => {
                    toastHelper.addSuccessToast(
                        "Your export is being processed. You'll receive both a notification on this page and an email, when it's ready to download.",
                        { autoDismiss: false }
                    );
                    analytics.track('study-export_csv', { study_id: this.state.study.id });
                })
                .catch(error => {
                    const errorText = services.parseAndTrackXhrErrors(error);
                    toastHelper.addErrorToast(errorText);
                });
        } else {
            const currentRequest = service_studies.getStudyPeoplePOST(request_options);
            this.setState({ study_people_loading: true });
            this.getStudyPeople_lastRequest = currentRequest;

            currentRequest
                .then(study_people_xhr => {
                    if (that.getStudyPeople_lastRequest === currentRequest) {
                        // if this is page 2, 3, 4, etc then lets add the response to the current dataset
                        // if its page 1, then just render this data
                        if (page > 1) {
                            const { study_people } = this.state;
                            const new_data = study_people_xhr.data;
                            study_people_xhr.data = study_people.data.concat(new_data);
                        }

                        this.setState({
                            study_people: study_people_xhr,
                            study_people_loading: false,
                            study_people_loading_more: false
                        });
                    } else {
                        console.log('IGNORING OLD');
                    }
                })
                .catch(error => {
                    const errorText = services.parseAndTrackXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });

                    // Reset on failure so loading-flag guards in
                    // handleModalSendCampaign_review, handleModalSendSms, and
                    // bulk-edit handlers don't block indefinitely.
                    if (that.getStudyPeople_lastRequest === currentRequest) {
                        this.setState({
                            study_people_loading: false,
                            study_people_loading_more: false
                        });
                    }
                });
        }
    }

    getPushEventNameViewChange() {
        const study_id = this.props.match.params.id;
        const prefix = config.is_eu_server ? 'eu-' : '';
        return `${prefix}study-${study_id}-sp-view-change`;
    }

    getStudyChangeEventName() {
        const study_id = this.props.match.params.id;
        const prefix = config.is_eu_server ? 'eu-' : '';
        return `${prefix}study-${study_id}-change`;
    }

    getAccountUsersXHR() {
        const { toastManager } = this.props;
        services
            .getAccountUsers()
            .then(account_users_xhr => {
                this.setState({ account_users: account_users_xhr });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getAvailabilityXHR() {
        const { toastManager } = this.props;
        const show_taken_spots = 1;
        service_studies
            .getStudyAvailability(this.props.match.params.id, show_taken_spots)
            .then(study_availability => {
                let study_availability_array = helpersStudy.generateStudyAvailabilityArray(
                    study_availability,
                    this.state.study.timezone,
                    this.state.study.timezone
                );
                this.setState({
                    study_availability_array
                });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getPanelsXHR() {
        const { toastManager } = this.props;

        service_people
            .getPanels()
            .then(panels_response => {
                this.setState({
                    panels: panels_response
                });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onUpdatePanels(new_panels) {
        this.setState({ panels: new_panels });
    }

    setUserViewingStudy() {
        service_studies
            .setUserViewingStudy(this.props.match.params.id, this.props.auth.user.id)
            .then(() => {})
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
            });
    }

    removeUserViewingStudy() {
        service_studies
            .removeUserViewingStudy(this.props.match.params.id, this.props.auth.user.id)
            .then(ret => {
                console.log(ret);
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
            });
    }

    handleSPLockChange(message) {
        try {
            if (message.type == 'lock') {
                console.log('LOCK', message.body);
                if (message.body && message.body.study_person_id) {
                    const { study_people } = this.state;
                    const sp_index_found = study_people.data.findIndex(sp => sp.id == message.body.study_person_id);
                    if (sp_index_found != -1) {
                        study_people.data[sp_index_found].users_viewing = message.body;
                        this.setState({ study_people });
                    }
                }
            } else if (message.type == 'unlock') {
                console.log('UNLOCK', message.body);
                if (message.body && message.body.study_person_id) {
                    const { study_people } = this.state;
                    const sp_index_found = study_people.data.findIndex(sp => sp.id == message.body.study_person_id);
                    if (sp_index_found != -1) {
                        study_people.data[sp_index_found].users_viewing = {};
                        this.setState({ study_people });
                    }
                }
            }
        } catch (e) {
            helpers.trackError(e);
        }
    }

    handleWindowClose(sendBeacon) {
        try {
            let shouldRemoveSPViewer = false;
            console.log('this.state.showModalStudyParticipant', this.state.showModalStudyParticipant);
            if (this.state.showModalStudyParticipant) {
                shouldRemoveSPViewer = true;
            }

            if (this.state.pushEventChannel) {
                this.state.pushEventChannel.unbind(this.getPushEventNameViewChange());
                this.state.pushEventChannel.unbind(this.getStudyChangeEventName());
                if (sendBeacon) {
                    console.log('handleWindowClose - BEACON');
                    const URL1 = service_studies.getRemoveUserViewingStudy(
                        this.props.match.params.id,
                        this.props.auth.user.id
                    );
                    navigator.sendBeacon(URL1);

                    if (shouldRemoveSPViewer) {
                        console.log('....shouldRemoveSPViewer', shouldRemoveSPViewer);
                        const URL2 = service_studies.getRemoveUserViewingStudyPerson(
                            this.props.match.params.id,
                            this.state.selectedStudyPerson.id
                        );
                        navigator.sendBeacon(URL2);
                    }
                } else {
                    console.log('handleWindowClose - REGULAR');
                    this.removeUserViewingStudy();
                    if (shouldRemoveSPViewer) {
                        this.handleCloseModalStudyParticipant();
                    }
                }
            }
        } catch (e) {
            helpers.trackError(e);
        }
    }

    componentDidMount() {
        analytics.track('study-view', { study_id: this.props.match.params.id });
        this.getStudy();
        this.getSenderProfilesXHR();
        this.getCustomDataColumnsXHR();
        this.getAccountUsersXHR();
        this.getPanelsXHR();

        this.setUserViewingStudy();
        this.setUserViewingStudy_interval = setInterval(() => {
            this.setUserViewingStudy();
        }, 30 * 1000);

        window.addEventListener('unload', () => {
            const sendBeacon = true;
            this.handleWindowClose(sendBeacon);
        });

        try {
            const that = this;
            if (window.pusher) {
                const channel = window.pusher.subscribe('panelfox-ws');
                this.setState({ pushEventChannel: channel }, () => {
                    this.state.pushEventChannel.bind(this.getPushEventNameViewChange(), message => {
                        if (message) {
                            that.handleSPLockChange(message);
                        }
                    });

                    this.state.pushEventChannel.bind(this.getStudyChangeEventName(), message => {
                        console.log('PUSHER message UPDATE', message);
                        if (message) {
                            if (message.type == 'sp-update') {
                                const sp_id_to_update = message.body;
                                service_studies.getStudyPerson(this.state.study.id, sp_id_to_update).then(found => {
                                    if (found) {
                                        let { study_people } = this.state;
                                        const sp_to_update_index = study_people.data.findIndex(
                                            element => element.id == sp_id_to_update
                                        );
                                        if (sp_to_update_index >= 0) {
                                            study_people.data[sp_to_update_index] = found;
                                            this.setState({ study_people });
                                        } else {
                                            console.log('sp_to_update_index not found for webhooks update');
                                        }
                                    }
                                });
                            } else if (message.type == 'study-viewers') {
                                console.log('update study vieweres!!!');
                                let uv_verified = [];
                                if (message.body) {
                                    message.body.forEach(uv => {
                                        if (uv && uv.user_id) {
                                            uv_verified.push(uv);
                                        }
                                    });
                                }
                                this.setState({ users_viewing: uv_verified });
                            } else {
                                console.log('type not found for event ' + this.getStudyChangeEventName());
                            }
                        }
                    });
                });
            }
        } catch (e) {
            helpers.trackError(e);
        }
    }

    componentWillUnmount() {
        this.isAnimationEnabled = false;
        this.handleWindowClose();

        if (this.setUserViewingStudy_interval) {
            clearInterval(this.setUserViewingStudy_interval);
        }
    }

    getCustomDataColumnsXHR() {
        services
            .getCustomDataColumnsXHR()
            .then(columns => {
                this.setState({ panel_columns: columns }, () => {
                    // Now that panel property metadata is available,
                    // re-derive the column list so previously subscribed
                    // panel properties show up.
                    this.rebuildTableColumns({ panelColumns: columns });
                });
            })
            .catch(error => {
                services.parseAndTrackXhrErrors(error);
            });
    }

    /**
     * Rebuild `tableColumns_all` from the current (or overridden) study,
     * panel columns, hidden list and panel-property subscription. Use an
     * override object for inputs that haven't yet been committed to
     * state (e.g. the fresh study in `getStudy` is inside a setState
     * callback queue).
     */
    rebuildTableColumns(overrides = {}) {
        const study = overrides.study || this.state.study;
        const panelColumns = overrides.panelColumns || this.state.panel_columns;
        const tableColumnsHidden = overrides.tableColumnsHidden || this.state.tableColumns_hidden;
        const panelPropertyIds = overrides.panelPropertyIds || this.state.panelPropertyIds;

        const tableColumns_all = buildTableColumns({
            study,
            panelColumns,
            tableColumnsHidden,
            panelPropertyIds
        });
        this.setState({ tableColumns_all });
    }

    handleOpenModalManageColumns() {
        this.setState({ showModalManageColumns: true, showDisplayedCustomColumns: false });
    }

    handleCloseModalManageColumns() {
        this.setState({ showModalManageColumns: false });
    }

    /**
     * Called with the resolved `{ tableColumnsHidden, panelPropertyIds }`
     * from the ManageColumns modal. Persists both to localStorage and
     * updates local state + the flat `tableColumns_all` derivation.
     */
    handleManageColumnsSaved({ tableColumnsHidden, panelPropertyIds }) {
        const studyId = this.props.match.params.id;

        store.set(panelPropertiesStorageKey(studyId), panelPropertyIds);

        this.saveColumnsShowHide(tableColumnsHidden);
        this.setState({ panelPropertyIds }, () => {
            this.rebuildTableColumns({ tableColumnsHidden, panelPropertyIds });
        });
    }

    toggleCheckbox(person_id) {
        const { p_checked } = this.state;

        // if person_id is in the array, remove it
        const foundPerson = p_checked.find(person => person.id == person_id);
        if (foundPerson) {
            const foundPerson_index = p_checked.indexOf(foundPerson);
            p_checked.splice(foundPerson_index, 1);
        } else {
            p_checked.push({ id: person_id });
        }

        const checkAllOrVisibleStatus = TABLE_CHECKED_STATUS.VISIBLE;

        this.setState({ p_checked, checkAllOrVisibleStatus });
    }

    clickSendEmail(type, options) {
        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }
        if (type == 'screen') {
            this.handleOpenModalSendCampaign('screen', this.state.p_checked, options);
        } else if (type == 'schedule') {
            this.handleOpenModalSendCampaign('schedule', this.state.p_checked);
        } else if (type == 'confirmation') {
            this.handleOpenModalSendCampaign('confirmation', this.state.p_checked);
        } else if (type == 'custom') {
            this.handleOpenModalSendCampaign('custom', this.state.p_checked);
        } else if (type == 'dscout') {
            this.handleOpenModalSendCampaign('dscout', this.state.p_checked, options);
        }
        const email_action = 'preview';
        this.handleModalSendCampaign_review(email_action);
    }

    performMassActionMove(move_to_study_state_id) {
        const { study_states } = this.state;
        const moveToStudyState = study_states.find(ss => ss.id == move_to_study_state_id);
        const moveToStudyState_index = study_states.indexOf(moveToStudyState);

        // get checked cards or columns
        const sp_checked = [];
        const ss_checked = [];
        study_states.forEach(ss => {
            // an entire column is checked
            if (ss.checked) {
                ss_checked.push(ss);
            }
            // entire column is not checked, lets find individual people
            else {
                ss.study_people.forEach(sp => {
                    if (sp.checked) {
                        sp_checked.push(sp);
                    }
                });
            }
        });

        // for simplicity, and assuming there is pagination in the Study States
        // only do the quick ui update if no "Select All" are checked.
        // which means only if individual cards are checked
        if (!ss_checked.length) {
            // this updates the UI to reflect latest board/column/card positions, no API calls here
            sp_checked.forEach((sp, key) => {
                const currentStudyState = study_states.find(ss => ss.id == sp.study_state_id);
                const currentStudyState_index = study_states.indexOf(currentStudyState);
                const currentStudyState_sp_index = currentStudyState.study_people.indexOf(sp);

                // remove SP from a single column
                study_states[currentStudyState_index].study_people.splice(currentStudyState_sp_index, 1);

                // add SP to a new single column
                sp.study_state_id = move_to_study_state_id;
                sp.checked = false;
                study_states[moveToStudyState_index].study_people.push(sp);
            });
        }

        // again, if no Columns have "Select All" we don't need to re-fetch the study
        const shouldRefetchStudy = !!ss_checked.length;

        // update the study states via API, and execute the callback
        this.xhrMoveStudyPeople(sp_checked, ss_checked, move_to_study_state_id, () => {
            if (shouldRefetchStudy) {
                this.getStudy();
            }
        });

        // update UI, only if no API call is made
        if (!shouldRefetchStudy) {
            this.renderNewStudyStates(study_states);
        }
    }

    onBoardColumnNew(sf) {
        const { toastManager } = this.props;
        const title = prompt('What would you like to title this tab?');

        if (title) {
            service_studies
                .studyAddStudyState(this.state.study.id, title, sf)
                .then(ss_new => {
                    const { study } = this.state;
                    study.study_states.push(ss_new);
                    this.setState({ study }, () => {
                        this.setSegment(ss_new.id);
                    });
                })
                .catch(error => {
                    const errorText = services.parseAndTrackXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    updateStudyState(segment, filters) {
        const { toastManager } = this.props;

        const study_state = this.state.study.study_states.find(ss => ss.id == segment);
        if (study_state) {
            if (filters) {
                study_state.filters = filters;
            }

            services
                .updateStudyState(this.state.study.id, study_state)
                .then(study_state_response => {
                    // update study states
                    const { study } = this.state;
                    const found_ss = study.study_states.find(ss => ss.id == study_state_response.id);
                    const index = study.study_states.indexOf(found_ss);
                    if (index > -1) {
                        study.study_states[index] = study_state_response;
                        this.setState({ study });
                    }

                    // saved!
                    toastManager.add('Filters saved successfully', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                })
                .catch(error => {
                    const errorText = services.parseAndTrackXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    saveStudy(study) {
        // detect change, and clear timeout if exists
        if (this.saveDelay) {
            clearTimeout(this.saveDelay);
        }

        // set timer for 200ms
        this.saveDelay = setTimeout(
            function() {
                this.saveStudyXHR(study);
            }.bind(this),
            300
        );
    }

    saveStudyXHR(study) {
        const { toastManager } = this.props;

        services
            .updateStudy(study)
            .then(() => {
                toastManager.add('Saved', {
                    appearance: 'info',
                    autoDismiss: true
                });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    makeShot(angle, originX) {
        this.animationInstance &&
            this.animationInstance({
                particleCount: 4,
                angle,
                decay: 0.94,
                spread: 40,
                origin: { x: originX, y: 1 },
                colors: ['#000000', '#ffffff']
            });
    }

    nextTickAnimation() {
        this.makeShot(65, 0);
        this.makeShot(115, 1);
        if (this.isAnimationEnabled && Date.now() < this.animationEnd) {
            requestAnimationFrame(this.nextTickAnimation);
        } else {
            this.isAnimationEnabled = false;
        }
    }

    runCelebration(durationSeconds) {
        analytics.track('study-mass_email-runCelebration');

        durationSeconds = durationSeconds || 5;
        if (!this.isAnimationEnabled) {
            this.animationEnd = Date.now() + durationSeconds * 1000;
            this.isAnimationEnabled = true;
            this.nextTickAnimation();
        }
    }

    getInstance(instance) {
        this.animationInstance = instance;
    }

    modalParticipantNotesCallbackFunction(action, study_person) {
        if (action == 'save') {
            const dontGetNewStudyPeople = true;
            this.getStudy(dontGetNewStudyPeople);
            // find SP in study
            this.updateStudyPersonInGrid(study_person);
        }
    }

    updateStudyPersonInGrid(study_person) {
        const { study_people } = this.state;
        const sp_found = study_people.data.find(sp => sp.id == study_person.id);
        if (sp_found) {
            const index = study_people.data.indexOf(sp_found);
            if (index > -1) {
                study_people.data[index] = study_person;
                this.setState({ study_people });
            }
        }
    }

    onSubmitAssignUserToPerson(user_id) {
        if (this.state.study_people_loading) {
            this.notifyPeopleStillLoading();
            return;
        }

        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        let custom_count_number = null;
        let people = [];
        let filters = null;
        let search_keyword = null;
        const { toastManager } = this.props;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        toastManager.add('Starting to assign participants', {
            appearance: 'success',
            autoDismiss: true
        });

        const filtering_options = {
            filters: JSON.stringify(filters),
            search_keyword: search_keyword,
            sort: JSON.stringify(this.state.sort),
            custom_count_number: custom_count_number
        };

        service_studies
            .assignUserToPeopleInStudy(
                this.state.study.id,
                people,
                user_id,
                filtering_options,
                this.state.checkAll_randomize
            )
            .then(assigned => {
                this.setState({ showModalAssignUser: false });
                this.deselectAll();
                this.getStudyPeople(this.state.segment);
                analytics.track('study-assign_user', { study_id: this.state.study.id });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getSenderProfilesXHR() {
        const { toastManager } = this.props;

        service_accounts
            .getSenderProfiles()
            .then(sender_profiles => {
                this.setState({ sender_profiles });

                // Set default sender profile using shared selection logic
                if (sender_profiles.length) {
                    const { sendCampaign } = this.state;

                    const { defaultSenderProfile } = getSenderProfileSelection(
                        sender_profiles,
                        this.props.auth.user.email,
                        this.state.study.sender_profile_id
                    );

                    if (defaultSenderProfile) {
                        sendCampaign.sender_profile_id = defaultSenderProfile.id;
                        sendCampaign.from_email = defaultSenderProfile.email;
                        sendCampaign.from_name = defaultSenderProfile.name;
                    }

                    this.setState({ sendCampaign });
                }
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    handleDisplayedTableColumns(columnId, isChecked) {
        const { tableColumns_all } = this.state;

        const found_col = tableColumns_all.find(column => column.id === columnId);

        if (found_col) {
            const index = tableColumns_all.indexOf(found_col);
            if (index > -1) {
                tableColumns_all[index].checked = isChecked;
                this.setColumnsShowHide(columnId, isChecked);
                this.setState({ tableColumns_all });

                analytics.track('study-columns-showhide', { columnIdShowHide: columnId + ' - ' + isChecked });
            }
        }
    }

    renderEmailCampaignPreview() {
        if (!this.state.emailCampaignPreview) {
            return;
        }

        const notificationCardTitle = this.isEmailingFeatureDisabled()
            ? NOTIFICATION_TITLE_DISABLED_EMAILING
            : NOTIFICATION_TITLE_HTML_NOT_ALLOWED;

        const notificationCardContent = this.isEmailingFeatureDisabled()
            ? NOTIFICATION_CONTENT_DISABLED_EMAILING
            : NOTIFICATION_CONTENT_HTML_NOT_ALLOWED;

        const selectedRecipientsCount = this.getSelectedRecipientsCount();

        return (
            <Box style={{ fontSize: '14px' }}>
                <H1 sx={{ color: '#606E85 !important' }}>
                    Confirm "{this.state.showModalSendCampaign_type}" automation
                </H1>
                {this.isEmailSendingDisabled() && (
                    <NotificationCard
                        type="danger"
                        icon={<FiInfo />}
                        title={notificationCardTitle}
                        content={notificationCardContent}
                        style={{ marginBottom: '16px' }}
                    />
                )}
                <div className="flex items-start gap-6 mb-4">
                    <div className="grow">
                        <Label>From</Label>
                        {this.state.sender_profiles.length == 0 ? (
                            <Box
                                style={{
                                    // border: '1px solid #ddd',
                                    background: '#f7f7f7',
                                    borderRadius: '4px',
                                    padding: '8px 16px',
                                    lineHeight: '16px',
                                    fontWeight: 500
                                }}
                            >
                                {this.state.sendCampaign.from_name}{' '}
                                {this.state.sendCampaign.from_email ? (
                                    <span>&lt;{this.state.sendCampaign.from_email}&gt;</span>
                                ) : (
                                    ''
                                )}
                            </Box>
                        ) : (
                            <SenderProfileSelect
                                senderProfiles={this.state.sender_profiles}
                                defaultValue={this.state.sendCampaign.sender_profile_id}
                                onChange={sender_profile_id => {
                                    const sender_profile = this.state.sender_profiles.find(
                                        sp => sp.id == sender_profile_id
                                    );
                                    const { sendCampaign } = this.state;
                                    sendCampaign.sender_profile_id = sender_profile_id;
                                    sendCampaign.from_email = sender_profile.email;
                                    sendCampaign.from_name = sender_profile.name;
                                    this.setState({ sendCampaign });
                                }}
                            />
                        )}
                    </div>
                    <div>
                        <Label>To</Label>
                        <Button
                            disabled={this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM}
                            variant="secondary"
                            className="!m-0"
                            onClick={() => {
                                this.setState({ isRecipientsPreviewModalOpen: true });
                            }}
                        >
                            <FiUser /> View {selectedRecipientsCount} recipient{selectedRecipientsCount > 1 ? 's' : ''}
                        </Button>
                    </div>
                    <div>
                        <Label htmlFor="recipients-cc-input">CC</Label>
                        <EmailCcTokenizer
                            openClassName={styles['cc-open-input']}
                            closeClassName={styles['cc-close-input']}
                            value={this.state.recipientsCc}
                            onChange={value => this.setState({ recipientsCc: value })}
                        />
                    </div>
                </div>

                <Label>Subject</Label>
                <Box
                    style={{
                        background: '#f7f7f7',
                        borderRadius: '4px',
                        padding: '8px 16px',
                        lineHeight: '16px',
                        fontWeight: 500,
                        margin: '0 0 16px 0',
                        color: this.state.sendCampaign.subject ? 'inherit' : 'red'
                    }}
                >
                    {this.state.sendCampaign.subject ? this.state.sendCampaign.subject : 'Subject missing'}
                </Box>
                <Label>Body</Label>
                {/*
                    sandbox="" for the same reason as the sent-email iframe in
                    ParticipantNotes: allow-scripts plus allow-same-origin cancels the
                    sandbox out, and a preview body is unsanitized template HTML with
                    magic strings already resolved. Rendering needs neither flag.
                */}
                <Box
                    as="iframe"
                    style={{ minHeight: '600px', width: '100%', border: 'none' }}
                    title="template preview"
                    sandbox=""
                    srcDoc={this.state.emailCampaignPreview}
                />
                <br />
                <br />
                <br />
            </Box>
        );
    }

    async handleCheckAllDropdownChange(checkAllOrVisibleStatus, checkAll_custom_count_number, checkAll_randomize) {
        const checkboxes = document.getElementsByName('person_id');
        const p_checked = [];

        for (let i = 0, n = checkboxes.length; i < n; i++) {
            if (checkAllOrVisibleStatus !== TABLE_CHECKED_STATUS.NONE) {
                p_checked.push({ id: checkboxes[i].dataset.personid });
            }
        }

        this.setState({ checkAllOrVisibleStatus });
        this.setState({ checkAll_custom_count_number });
        this.setState({ checkAll_randomize });
        this.setState({ showCheckAllDropdown: false });
        this.setState({ p_checked });
    }

    deselectAll() {
        this.setState({
            checkAllOrVisibleStatus: TABLE_CHECKED_STATUS.NONE,
            p_checked: []
        });
    }

    /**
     * Display warning about fetching study people
     */
    notifyPeopleStillLoading() {
        this.props.toastHelper.addWarningToast('Panelists are still loading. Please wait before sending.');
    }

    setSegment(segment_id) {
        if (this.state.study && this.state.study.study_states) {
            const study_state = this.state.study.study_states.find(ss => ss.id == segment_id);
            if (study_state) {
                this.setState(
                    { screenerFilters: study_state.filters, segment: segment_id, study_people_loading: true },
                    () => {
                        this.deselectAll();
                        this.getStudyPeople(segment_id);
                    }
                );
                this.setCachedSegmentChoice(segment_id);
            }
        }
    }

    changeTabOrder(newOrder) {
        const { toastManager } = this.props;
        service_studies
            .updateStudyStatesOrder(this.props.match.params.id, newOrder)
            .then(study_states => {
                // we already saved it in the UI
                console.log(4);
            })
            .catch(error => {
                console.log(error);
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    getNumberPeopleSelected() {
        let count;
        if (this.state.checkAllOrVisibleStatus == TABLE_CHECKED_STATUS.ALL) {
            count = this.state.study_people.total;
        } else if (this.state.checkAllOrVisibleStatus == TABLE_CHECKED_STATUS.CUSTOM) {
            count = this.state.checkAll_custom_count_number;
        } else {
            count = this.state.p_checked.length;
        }
        return count;
    }

    generateSendToNumberPeople() {
        if (this.state.isSendingCampaign == true || this.state.isSendingSmsCampaign == true) {
            return `Processing...`;
        } else {
            const count = this.getNumberPeopleSelected();

            return `Send to ${count} ${count > 1 ? 'people' : 'person'}`;
        }
    }

    createFilterQuery() {
        const query = {
            sort: JSON.stringify(this.state.sort),
            randomize: this.state.checkAll_randomize
        };

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            query.filters = this.state.screenerFilters;
            query.search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            query.filters = this.state.screenerFilters;
            query.search_keyword = this.state.search_keyword;
            query.custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            query.people_as_array = this.state.p_checked;
        }

        return query;
    }

    onProcessBulkEdit(e) {
        e.preventDefault();

        if (this.state.study_people_loading) {
            this.notifyPeopleStillLoading();
            return;
        }

        if (!this.state.p_checked.length) {
            alert('Please "checkbox" at least one study participant');
            return;
        }

        let people = [];
        let filters = null;
        let search_keyword = null;
        const { toastManager } = this.props;
        let custom_count_number = null;

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
        } else if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            filters = this.state.screenerFilters;
            search_keyword = this.state.search_keyword;
            custom_count_number = this.state.checkAll_custom_count_number;
        } else {
            people = this.state.p_checked;
        }

        const bulk_edit_field_id = this.state.bulk_edit_field.id;
        const bulk_edit_value = this.state.bulk_edit_value;

        if (!confirm(`Are you sure you want to update these respondents?`)) {
            return;
        }

        service_studies
            .bulkSpEdit(
                this.state.study.id,
                people, // be careful, this sends a Person model, not Study Person :)
                filters,
                search_keyword,
                JSON.stringify(this.state.sort),
                custom_count_number,
                bulk_edit_field_id,
                bulk_edit_value,
                this.state.checkAll_randomize
            )
            .then(people => {
                toastManager.add('Successful bulk edit', {
                    appearance: 'success',
                    autoDismiss: true
                });

                this.setState({
                    showModalBulkEditSp: false,
                    bulk_edit_field: {},
                    bulk_edit_value: null
                });
                this.deselectAll();
                this.getStudyPeople(this.state.segment);
                analytics.track('study-bulk_edit', {
                    study_id: this.state.study.id,
                    bulk_edit_field_id: bulk_edit_field_id
                });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: false
                });
            });
    }

    onBulkEditParticipantStatusValueChange(e) {
        this.setState({ bulk_edit_value: e.target.value });
    }

    onBulkEditParticipantSessionValueChange(spot) {
        console.log('onBulkEditParticipantSessionValueChange', spot);
        this.setState({ bulk_edit_value: spot });
    }

    customAttributeChanged(e, study_sp_attribute) {
        let val;
        if (study_sp_attribute.type && study_sp_attribute.type == 'checkbox') {
            const checked = [];
            const checkboxes = document.getElementsByName(`study_cspa_${study_sp_attribute.id}`);
            for (let i = 0, n = checkboxes.length; i < n; i++) {
                if (checkboxes[i].checked) {
                    checked.push(checkboxes[i].value);
                }
            }
            console.log('checkboxes', checkboxes, checked);
            val = JSON.stringify(checked);
        } else {
            val = e.target.value;
        }

        this.setState({ bulk_edit_value: val });
    }

    hasMassSmsEnabled() {
        let enabled = false;
        try {
            enabled = helpers.hasFeatureEnabled(this.props.auth.account, PAID_FEATURE.SMS_MASS);
        } catch (e) {
            helpers.trackError(e);
        }
        return enabled;
    }

    renderBulkEditValueChanger() {
        let render = [];
        if (this.state.bulk_edit_field.id) {
            render.push(<Label mt={3}>New value</Label>);

            if (this.state.bulk_edit_field.id === SP_PARTICIPANT_STATUS) {
                render.push(
                    <Select onChange={this.onBulkEditParticipantStatusValueChange} value={this.state.bulk_edit_value}>
                        {Object.keys(SP_STATUS_KEY_TITLE).map(key => {
                            return <option value={key}>{SP_STATUS_KEY_TITLE[key]}</option>;
                        })}
                    </Select>
                );
            }

            if (this.state.bulk_edit_field.id === SP_PARTICIPANT_LOCATION) {
                if (!this.state.study.location_type) {
                    render.push(
                        <Input
                            value={this.state.bulk_edit_value}
                            onChange={e => this.setState({ bulk_edit_value: e.target.value })}
                        />
                    );
                } else {
                    render.push(
                        <Badge type="warn">
                            A global location is set for this study, so individual locations can not be updated. To
                            change this, go to Study &gt; Scheduling &gt; Calendar Event.
                        </Badge>
                    );
                }
            }

            // add Participant Session Options
            if (this.state.bulk_edit_field.id === SP_PARTICIPANT_SESSION) {
                const sessionSpot = this.getSession(this.state.study_availability_array, this.state.spot);

                render.push(
                    <>
                        <Button
                            type="button"
                            variant="secondary-gray"
                            onClick={e => {
                                e.preventDefault();
                                this.setState({ showSchedulingDropdown: true });
                            }}
                        >
                            {sessionSpot ? sessionSpot : 'Unscheduled'}
                            <FiChevronDown
                                style={{
                                    margin: '3px 0 0 4px'
                                }}
                            />
                        </Button>
                        {this.state.showSchedulingDropdown === true && (
                            <div style={{ position: 'relative' }}>
                                <NiceDropdown
                                    width={200}
                                    positionLeft="0px"
                                    positionTop="4px"
                                    adjustHeight
                                    items={[{ title: 'Unscheduled', id: '' }, ...this.state.study_availability_array]}
                                    onChange={(spot, event) => {
                                        event.stopPropagation();
                                        this.onBulkEditParticipantSessionValueChange(spot);
                                        this.setState({ spot: spot, showSchedulingDropdown: false });
                                    }}
                                    onClose={() => this.setState({ showSchedulingDropdown: false })}
                                    style={{ content: { overflow: 'inherit' } }}
                                    renderBottomStickyButton={
                                        <Button
                                            variant="secondary"
                                            type="button"
                                            onClick={() => this.setState({ showModalSessionDatepicker: true })}
                                            mr={0}
                                        >
                                            <FiCalendar /> Set Custom
                                        </Button>
                                    }
                                />
                            </div>
                        )}
                        <SessionDatepickerModal
                            isOpen={this.state.showModalSessionDatepicker}
                            onClose={() => this.setState({ showModalSessionDatepicker: false })}
                            timezone={this.state.study.timezone}
                            onSubmit={spot => {
                                this.onBulkEditParticipantSessionValueChange(spot);
                                this.setState({ spot, showSchedulingDropdown: false });
                            }}
                        />
                    </>
                );
            }

            // contains cspa key
            else if (this.state.bulk_edit_field.id.indexOf('cspa_') > -1) {
                let render_edit_cspa;
                const cspa_id = this.state.bulk_edit_field.id.substring(5);
                console.log('cspa_id', cspa_id);

                if (this.state.study && this.state.study.custom_sp_attributes) {
                    const found_cspa = this.state.study.custom_sp_attributes.find(
                        study_cspa => study_cspa.id == cspa_id
                    );

                    if (found_cspa) {
                        render_edit_cspa = helpersStudy.renderCspaEdit(
                            found_cspa,
                            this.state.bulk_edit_value,
                            this.customAttributeChanged
                        );
                    }
                }

                render.push(render_edit_cspa);
            }
        } else {
            render.push(
                <Box mt={3} fontSize={1}>
                    Please select a column
                </Box>
            );
        }

        return render;
    }

    getBulkEditableFields() {
        let fields = [];

        // Add Participant Status Field
        fields.push({
            label: true,
            title: 'Study participation'
        });
        fields.push({ id: SP_PARTICIPANT_STATUS, title: 'Participant Status' });

        // Add Participant Session Field
        fields.push({ id: SP_PARTICIPANT_SESSION, title: 'Participant Session' });

        // Add Participant Location Field
        fields.push({ id: SP_PARTICIPANT_LOCATION, title: 'Participant Location' });

        // Add Custom Study Attribute Field
        if (this.state.study && this.state.study.custom_sp_attributes && this.state.study.custom_sp_attributes.length) {
            fields.push({
                label: true,
                title: 'Custom study attributes'
            });
            this.state.study.custom_sp_attributes.forEach(cspa => {
                fields.push({
                    id: `cspa_${cspa.id}`,
                    title: cspa.title
                });
            });
        }

        return fields;
    }

    emailAttachmentUploadButton() {
        const { toastManager } = this.props;
        document.getElementById('email_attachment_upload').click();
        document.getElementById('email_attachment_upload').onchange = e => {
            const formData = new FormData();
            const file = e.target.files[0];
            const current_file_size = file.size;

            console.log('filesize', current_file_size);

            // sum up attachment file sizes, including this new one
            let sum_attachments_file_sizes = 0;
            sum_attachments_file_sizes += current_file_size;

            this.state.email_attachments.forEach(a => {
                if (a && a.filesize) {
                    sum_attachments_file_sizes += a.filesize;
                }
            });

            console.log('sum_attachments_file_sizes', sum_attachments_file_sizes);

            if (sum_attachments_file_sizes > MAX_EMAIL_ATTACHMENTS_SIZE) {
                analytics.track('study-mass_email-attachment-TOO_BIG');
                alert('Sum of all attachments can not exceed ' + helpers.humanFileSize(MAX_EMAIL_ATTACHMENTS_SIZE));
                return;
            }
            formData.append('attachment', file);

            this.setState({ email_attachment_isUploading: true });

            services
                .uploadEmailAttachment(formData)
                .then(file_object => {
                    let { email_attachments } = this.state;

                    // add file size to display
                    file_object.filesize = current_file_size;

                    email_attachments.push(file_object);
                    /*{
                        'filename': 'awhattt'+email_attachments.length+'.jpeg',
                        'filepath': 'https://google.com'
                    }*/
                    this.setState({
                        email_attachments,
                        email_attachment_isUploading: false
                    });

                    analytics.track('study-mass_email-attachment-add');
                })
                .catch(error => {
                    this.setState({
                        email_attachment_isUploading: false
                    });

                    const errorText = services.parseAndTrackXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        };
    }

    getSelectedRecipientsCount() {
        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.ALL) {
            return this.state.study_people.total;
        }

        if (this.state.checkAllOrVisibleStatus === TABLE_CHECKED_STATUS.CUSTOM) {
            return this.state.checkAll_custom_count_number;
        }

        return this.state.p_checked.length;
    }

    tableColumnsOrdered() {
        const { tableColumns_all, tableColumns_order } = this.state;

        tableColumns_all.forEach(tc => {
            // see if there are any ordered columns
            if (tableColumns_order && tableColumns_order[tc.id] !== undefined) {
                // set order, otherwise null
                tc.order = tableColumns_order[tc.id];
            } else {
                tc.order = undefined;
            }
        });

        tableColumns_all.sort(helpersStudy.compareColumnOrder);

        return tableColumns_all;
    }

    resetTableColumns() {
        this.saveColumnsOrder(DEFAULT_COLUMNS_ORDER);
        this.saveColumnsShowHide(DEFAULT_COLUMNS_HIDDEN);
        // Also drop any panel-property subscriptions so "Reset Columns"
        // truly returns the table to its default narrow view.
        const studyId = this.props.match.params.id;

        store.remove(panelPropertiesStorageKey(studyId));

        location.reload();
    }

    renderViewingUsers() {
        let render = [];

        let users_viewing = cloneDeep(this.state.users_viewing);

        if (env == 'development') {
            users_viewing.push({
                user_id: 999999999,
                name: 'Manually added for testing locally.'
            });
        }

        try {
            const avatar_style = { width: '24px', height: '24px', margin: '0 0 0 4px' };
            if (users_viewing) {
                users_viewing.map(uv => {
                    if (uv && uv.user_id && uv.user_id != this.props.auth.user.id) {
                        // @todo add initials not FiUser
                        // add tooltip

                        render.push(
                            <Box>
                                {uv.avatar ? (
                                    <img
                                        src={uv.avatar}
                                        data-tip
                                        data-for={`user-viewing-${uv.user_id}`}
                                        style={avatar_style}
                                        alt={uv.name}
                                        className="basic-avatar"
                                    />
                                ) : (
                                    <span data-tip data-for={`user-viewing-${uv.user_id}`} className="basic-avatar">
                                        {helpers.getUserInitials(uv)}
                                    </span>
                                )}
                                <ReactTooltip id={`user-viewing-${uv.user_id}`} effect="solid" place="top">
                                    <Box>{uv.name}</Box>
                                </ReactTooltip>
                            </Box>
                        );
                    }
                });
            }
        } catch (e) {
            helpers.trackError(e);
        }

        // we need to move this container a bit up if we are rendering the "integrations" container
        let positionTop = '22px';
        if (this.state.study.integrations && this.state.study.integrations.length) {
            positionTop = '12px';
        }

        return <Flex sx={{ gridGap: '4px' }}>{render}</Flex>;
    }

    // to show the selected session
    getSession(availabilities, spot) {
        try {
            if (spot) {
                return moment.tz(spot, this.state.study.timezone).format(MOMENT_HUMAN_DATE);
            }
        } catch (e) {
            helpers.trackError(e);
        }
    }

    bulkDownloadFiles() {
        const { toastManager } = this.props;

        /*
            bulkFileDownloadStatus
            0/false = not doing anything
            1 = generating
            2 = ready for download
        */
        this.setState({ bulkFileDownloadStatus: 1 });

        service_studies
            .bulkDownloadFile(this.state.study.id)
            .then(download_link => {
                toastManager.add('Your bulk file download is ready', {
                    appearance: 'success',
                    autoDismiss: true
                });
                this.setState({
                    bulkFileDownloadStatus: 2,
                    bulkFileDownloadLink: download_link
                });
            })
            .catch(error => {
                this.setState({ bulkFileDownloadStatus: 0 });
                const errorText = services.parseAndTrackXhrErrors(error);
                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    /**
     * Handles study status change asynchronously
     * @param {string} status - The new status value for the study
     */
    async onStudyStatusChange(status) {
        const { toastHelper } = this.props;

        const study = { ...this.state.study };

        try {
            await services.updateStudyStatus(study, status);
            toastHelper.addSuccessToast('Status updated');
            study.status = status;
            this.setState({ study });
        } catch (error) {
            const errorText = services.parseAndTrackXhrErrors(error);
            toastHelper.addErrorToast(errorText);
        }
    }

    renderBulkDownload() {
        if (this.state.bulkFileDownloadStatus == 2) {
            return (
                <a href={this.state.bulkFileDownloadLink} target="_blank">
                    <Button type="button" variant="secondary" className="success">
                        <FiDownloadCloud /> Download Files (.zip)
                    </Button>
                </a>
            );
        } else {
            return (
                <Button
                    type="button"
                    variant="secondary"
                    onClick={this.bulkDownloadFiles}
                    disabled={this.state.bulkFileDownloadStatus == 1}
                >
                    {this.state.bulkFileDownloadStatus == 1 ? 'Processing...' : 'Export Bulk Files'}
                </Button>
            );
        }
    }

    getStudyStateCountBadge(ss, isActive) {
        return (
            <span className={`label-highlight-number ${isActive ? 'active' : ''}`} style={{ marginLeft: '8px' }}>
                {helpers.numberFormat(ss.count)}
            </span>
        );
    }

    getStudyStateTitleWithCount(ss, isActive) {
        return (
            <>
                <span style={{ maxWidth: '200px' }} className="ellipsis va-top inline-block">
                    {ss.title}
                </span>
                {this.getStudyStateCountBadge(ss, isActive)}
            </>
        );
    }

    getStudyStatesList() {
        return this.state.study.study_states.map(ss => {
            return {
                id: ss.id,
                title: ss.title,
                suffix: this.getStudyStateCountBadge(ss),
                order: ss.order
            };
        });
    }

    renderSavedTabsLabel() {
        let segmentTitle = '';
        if (this.state.segment) {
            let ssFound = this.state.study.study_states.find(ss => ss.id == this.state.segment);
            if (ssFound) {
                segmentTitle = this.getStudyStateTitleWithCount(ssFound, true);
            } else {
                segmentTitle = 'Segment not found';
            }
        }
        return segmentTitle;
    }

    renderSavedTabs() {
        return (
            <Box sx={{ display: 'inline-block' }}>
                <span className="vertical-divider"></span>
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Button variant="transparent" onClick={() => this.setState({ showTabsDropdown: true })}>
                        <span className="bold">Segment:</span> {this.renderSavedTabsLabel()}
                        <FiChevronDown style={{ margin: '4px 0 0 8px' }} />
                    </Button>
                    {this.state.showTabsDropdown && (
                        <NiceDropdown
                            defaultLabel="Show"
                            showSearch
                            adjustHeight
                            height="320px"
                            width="320px"
                            value={this.state.segment}
                            canReorder={true}
                            revealEllipsis={true}
                            positionLeft="0px"
                            onReorder={newOrder_byId => {
                                let { study } = this.state;
                                let newSSOrder = [];
                                newOrder_byId.forEach((id, index) => {
                                    let found_ss = study.study_states.find(ss => ss.id == id);
                                    if (found_ss) {
                                        // set new order
                                        found_ss.order = index;
                                        newSSOrder.push(found_ss);
                                    }
                                });
                                study.study_states = newSSOrder;
                                this.setState({ study }, () => {
                                    this.changeTabOrder(newSSOrder);
                                });
                            }}
                            onClose={() => {
                                this.setState({ showTabsDropdown: false });
                            }}
                            items={this.getStudyStatesList()}
                            onChange={(segmentId, b, c) => {
                                console.log('segments onChange', segmentId, b, c);
                                this.setSegment(segmentId);
                            }}
                            renderBottomStickyButton={
                                <Button
                                    variant="secondary"
                                    onClick={() => this.onBoardColumnNew(this.state.screenerFilters)}
                                    mr={0}
                                >
                                    + Add Segment
                                </Button>
                            }
                        />
                    )}
                </Box>
                <span className="vertical-divider"></span>
            </Box>
        );
    }

    render() {
        let select_modal_assign_users_list = this.state.account_users.map(account_user => {
            return {
                id: account_user.user.id,
                title: account_user.user.name
            };
        });
        select_modal_assign_users_list.unshift({ id: -1, title: 'Un-assign' });

        const ssDropdownOptions = [];
        if (this.state.study_states) {
            this.state.study_states.forEach(ss => {
                if ((ss.lock && ss.toggle) || ss.type == 'basic' || ss.type == 'candidates') {
                    ssDropdownOptions.push({ id: ss.id, title: ss.title });
                }
            });
        }

        // check if screener has any data
        let screener_has_data = false;
        this.state.study.screener.forEach(page => {
            page.forEach(question => {
                screener_has_data = true;
            });
        });

        let mass_message_items = [];

        if (screener_has_data) {
            mass_message_items.push({
                title: 'Send screener',
                onClick: () => {
                    this.clickSendEmail('screen');
                }
            });
        }

        this.state.study.screeners.forEach(screener => {
            mass_message_items.push({
                icon: helpersScreener.getScreenerIcon(screener),
                title: `Send screener "${screener.title}"`,
                onClick: () => {
                    this.clickSendEmail('screen', { screener_id: screener.id });
                }
            });
        });

        mass_message_items = mass_message_items.concat([
            {
                title: 'Send scheduling request',
                onClick: () => {
                    this.clickSendEmail('schedule');
                }
            },
            {
                title: 'Send scheduling confirmation',
                onClick: () => {
                    this.clickSendEmail('confirmation');
                }
            },
            {
                title: 'Send custom email',
                onClick: () => {
                    this.clickSendEmail('custom');
                }
            },
            {
                id: 'divider',
                divider: true
            }
        ]);

        const smsMessageItem = {
            title: 'Send SMS',
            disabled: true,
            suffix: <UpgradeButton type="sms-mass" />,
            onClick: () => {
                this.setState({ showModalSMSMessage: true });
            }
        };

        // if user has sms-mass feature enabled, then enable the button
        if (this.hasMassSmsEnabled()) {
            smsMessageItem.disabled = false;
            smsMessageItem.suffix = undefined;
        }

        mass_message_items = mass_message_items.concat([smsMessageItem]);

        let mass_email_actions = [
            {
                title: `Send test email`,
                icon: <FiSend />,
                onClick: e => {
                    const email_action = 'test';
                    this.handleModalSendCampaign_review(email_action);
                }
            },
            {
                title: `Schedule to send`,
                icon: <FiCalendar />,
                onClick: e => {
                    this.setState({ showModalScheduleSend: true });
                }
            },
            {
                title: `Edit email`,
                icon: <FiEdit />,
                onClick: e => {
                    this.setState({ showModalSendCampaign_editMode: true });
                }
            }
        ];
        if (helpersStudy.shouldShowEmailAttachmentButton(this.props.auth.account)) {
            mass_email_actions.push({
                title: `Add attachment`,
                disabled: this.state.email_attachment_isUploading,
                icon: <FiPaperclip />,
                onClick: e => {
                    this.emailAttachmentUploadButton();
                }
            });
        }

        const studyStatusItems = [
            { title: STUDY_STATUS[STUDY_STATUS_DRAFT], id: STUDY_STATUS_DRAFT },
            { title: STUDY_STATUS[STUDY_STATUS_ACTIVE], id: STUDY_STATUS_ACTIVE },
            { title: STUDY_STATUS[STUDY_STATUS_PAUSED], id: STUDY_STATUS_PAUSED },
            { title: STUDY_STATUS[STUDY_STATUS_COMPLETE], id: STUDY_STATUS_COMPLETE }
        ];

        const dscoutIntegration = this.getDscoutIntegration();

        return (
            <Flex style={{ width: '100%' }}>
                <AppPageWrapper>
                    <Helmet>
                        <title>{this.state.study.title}</title>
                    </Helmet>

                    <AppPageWrapperSectionHeader className="experience experience-no-subnav">
                        <Box>
                            <BreadcrumbBack to="/studies">Back to all studies</BreadcrumbBack>
                            <Flex>
                                <BreadcrumbTitle isLoading={this.state.study_loading} title={this.state.study.title} />
                                {!this.state.study_loading && (
                                    <Box sx={{ position: 'relative', marginLeft: '10px' }}>
                                        <Button
                                            variant="transparent"
                                            onClick={() => this.setState({ showStatusDropdown: true })}
                                        >
                                            <Badge
                                                type={STUDY_STATUS_BADGE_TYPE[this.state.study.status]}
                                                css={{
                                                    width: '88px',
                                                    verticalAlign: 'top'
                                                }}
                                            >
                                                {STUDY_STATUS[this.state.study.status]}
                                            </Badge>
                                            <FiChevronDown style={{ margin: '6px 0 0 5px' }} />
                                        </Button>
                                        {this.state.showStatusDropdown && (
                                            <NiceDropdown
                                                positionLeft="0px"
                                                width="240px"
                                                onClose={() => {
                                                    this.setState({ showStatusDropdown: false });
                                                }}
                                                onChange={this.onStudyStatusChange}
                                                items={studyStatusItems}
                                                value={this.state.study.status}
                                            />
                                        )}
                                    </Box>
                                )}
                            </Flex>
                        </Box>
                        <Flex sx={{ position: 'absolute', top: '12px', right: '32px' }}>
                            {this.renderViewingUsers()}
                            {dscoutIntegration && (
                                <DscoutIntegration
                                    integration={dscoutIntegration}
                                    studyId={this.state.study.id}
                                    onDelete={() => this.getStudy()}
                                />
                            )}
                        </Flex>
                    </AppPageWrapperSectionHeader>

                    <Flex sx={{ width: '100%', justifyContent: 'space-between' }}>
                        <StudyPageSubNav
                            study_id={this.props.match.params.id}
                            study={this.state.study}
                            onClickParticipant={sp => {
                                this.handleCardClick(sp.id);
                            }}
                        />
                    </Flex>
                    <AppPageWrapperSectionSubHeader
                        style={{ background: '#fff', flexDirection: 'column', paddingBottom: '4px' }}
                    >
                        <Flex mt={'16px'} mb={0} justifyContent="space-between">
                            <Box>
                                <Flex flexDirection="column">
                                    <Box mb={2}>
                                        <Box
                                            style={{
                                                color: 'black',
                                                position: 'relative',
                                                display: 'inline-block',
                                                verticalAlign: 'top',
                                                marginTop: '5px'
                                            }}
                                        >
                                            <span className="bold">
                                                Found {helpers.numberFormat(this.state.study_people.total)}{' '}
                                                {this.state.study_people.total == 1 ? 'person' : 'people'}{' '}
                                            </span>
                                        </Box>

                                        {this.renderSavedTabs()}

                                        {this.state.study_people.data.length > 0 && (
                                            <>
                                                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                                    <Button
                                                        variant="secondary-gray"
                                                        disabled={
                                                            this.state.study.status == STUDY_STATUS_DRAFT ||
                                                            this.state.study_people_loading
                                                        }
                                                        title={
                                                            this.state.study_people_loading
                                                                ? 'Loading panelists, please wait.'
                                                                : undefined
                                                        }
                                                        mr={3}
                                                        onClick={() => {
                                                            this.setState({
                                                                showEmailMoreDropdown: true
                                                            });
                                                        }}
                                                    >
                                                        <FiSend /> Send message{' '}
                                                        <FiChevronDown
                                                            style={{
                                                                marginRight: 0
                                                            }}
                                                        />
                                                    </Button>
                                                    {this.state.showEmailMoreDropdown == true && (
                                                        <NiceDropdown
                                                            positionLeft="0px"
                                                            width="240px"
                                                            onClose={() => {
                                                                this.setState({
                                                                    showEmailMoreDropdown: false
                                                                });
                                                            }}
                                                            items={mass_message_items}
                                                        />
                                                    )}
                                                </Box>
                                                <Box style={{ display: 'inline-block', position: 'relative' }}>
                                                    <Button
                                                        variant="secondary-gray"
                                                        disabled={this.state.study_people_loading}
                                                        title={
                                                            this.state.study_people_loading
                                                                ? 'Loading panelists, please wait.'
                                                                : undefined
                                                        }
                                                        mr={0}
                                                        onClick={() => {
                                                            this.setState({
                                                                showFiltersMoreDropdown: true
                                                            });
                                                        }}
                                                    >
                                                        Bulk Actions{' '}
                                                        <FiChevronDown
                                                            style={{
                                                                marginRight: 0
                                                            }}
                                                        />
                                                    </Button>
                                                    {this.state.showFiltersMoreDropdown == true && (
                                                        <NiceDropdown
                                                            onClose={() => {
                                                                this.setState({
                                                                    showFiltersMoreDropdown: false
                                                                });
                                                            }}
                                                            hasSubmenu
                                                            width={'300px'}
                                                            items={[
                                                                {
                                                                    id: 'invite-to-dscout',
                                                                    title: `Invite to Dscout`,
                                                                    icon: <FiExternalLink />,
                                                                    hide: this.isDscoutIntegrationDisabled(),
                                                                    disabled: !this.props.auth.user.dscout_connected,
                                                                    tooltip: this.props.auth.user.dscout_connected ? (
                                                                        undefined
                                                                    ) : (
                                                                        <div>
                                                                            Missing Dscout token, please reach out to{' '}
                                                                            {config.SUPPORT_EMAIL} to set this up.
                                                                        </div>
                                                                    ),
                                                                    onClick: () => {
                                                                        this.setState({
                                                                            showModalDscoutMissions: true
                                                                        });
                                                                    }
                                                                },
                                                                {
                                                                    title: `Edit respondents`,
                                                                    icon: <FiEdit />,
                                                                    onClick: () => {
                                                                        if (this.checkIfAnyoneChecked()) {
                                                                            this.setState({
                                                                                showModalBulkEditSp: true
                                                                            });
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    title: `Pay respondents`,
                                                                    icon: <FiDollarSign />,
                                                                    onClick: () => {
                                                                        this.bulkPayXHR();
                                                                    }
                                                                },
                                                                {
                                                                    title: 'Add to another study',
                                                                    icon: <FiLayers />,
                                                                    onClick: () => this.openShareStudyPeopleModal()
                                                                },
                                                                {
                                                                    title: `Upload respondents`,
                                                                    icon: <FiUploadCloud />,
                                                                    onClick: () => {
                                                                        this.handleOpenModalParticipantImport();
                                                                    }
                                                                },
                                                                {
                                                                    title: `Assign to user`,
                                                                    icon: <FiUserPlus />,
                                                                    onClick: () => {
                                                                        this.setState({ showModalAssignUser: true });
                                                                    }
                                                                },

                                                                {
                                                                    title: `Delete responses`,
                                                                    icon: <FiFileMinus />,
                                                                    feature_launched_at: moment(
                                                                        '10-25-2022',
                                                                        'MM-DD-YYYY'
                                                                    ),
                                                                    submenu: this.state.study.screeners.map(
                                                                        screener => {
                                                                            return {
                                                                                title: screener.title,
                                                                                onClick: () => {
                                                                                    this.handleRemoveScreenerResponse(
                                                                                        screener
                                                                                    );
                                                                                }
                                                                            };
                                                                        }
                                                                    )
                                                                },
                                                                {
                                                                    title: `Visualize data`,
                                                                    icon: <FiPieChart />,
                                                                    feature_launched_at: moment(
                                                                        '04-01-2022',
                                                                        'MM-DD-YYYY'
                                                                    ),
                                                                    //hide: true | false,
                                                                    submenu: this.state.study.screeners.map(
                                                                        screener => {
                                                                            return {
                                                                                title: screener.title,
                                                                                onClick: () => {
                                                                                    this.setState({
                                                                                        showModalDataViz: true,
                                                                                        datavizScreenerId: screener.id
                                                                                    });
                                                                                }
                                                                            };
                                                                        }
                                                                    )
                                                                },

                                                                {
                                                                    title: `Export`,
                                                                    icon: <FiDownloadCloud />,
                                                                    onClick: () => {
                                                                        this.setState({
                                                                            showModalExportCsv: true,
                                                                            bulkFileDownloadStatus: 0
                                                                        });
                                                                    }
                                                                },
                                                                { id: 'divider', divider: true },
                                                                {
                                                                    title: `Delete from study`,
                                                                    icon: <FiXCircle />,
                                                                    color: 'red',
                                                                    onClick: () => {
                                                                        this.handleRemoveStudyPeople();
                                                                    }
                                                                }
                                                            ]}
                                                        />
                                                    )}
                                                </Box>
                                            </>
                                        )}

                                        {!this.state.study_people_loading && !this.state.study_people.data.length && (
                                            <Button
                                                type="button"
                                                variant="secondary-gray"
                                                ml={3}
                                                onClick={() => this.handleOpenModalParticipantImport()}
                                            >
                                                <FiUploadCloud /> Upload respondents
                                            </Button>
                                        )}
                                    </Box>
                                </Flex>
                            </Box>
                            <Box sx={{ position: 'relative' }}>
                                <Flex flexDirection="row" fontSize={1}>
                                    <Box>
                                        <InputSearch
                                            mr={3}
                                            type="text"
                                            value={this.state.search_keyword}
                                            onChange={this.onSearchKeywordChange}
                                            placeholder="Search Name, Email, or Phone"
                                            sx={{ width: '250px' }}
                                        />
                                    </Box>

                                    <Box>
                                        <Button
                                            variant="secondary-gray"
                                            mr={0}
                                            onClick={() => {
                                                this.setState({
                                                    showScreenerFilters: true
                                                });
                                            }}
                                        >
                                            <FiFilter /> Filters{' '}
                                            {this.state.screenerFilters.length > 0 ? (
                                                <span
                                                    className="label-highlight-number active"
                                                    style={{ marginLeft: '4px' }}
                                                >
                                                    {this.state.screenerFilters.length}
                                                </span>
                                            ) : (
                                                ''
                                            )}
                                        </Button>
                                    </Box>

                                    <Box ml={3} sx={{ position: 'relative' }}>
                                        <Button
                                            variant="secondary-gray"
                                            className="secondary-icon"
                                            onClick={() => this.setState({ showDisplayedCustomColumns: true })}
                                        >
                                            <FiColumns />
                                            <FiChevronDown style={{ marginRight: 0 }} />
                                        </Button>
                                        {this.state.showDisplayedCustomColumns && (
                                            <NiceDropdown
                                                showSearch
                                                adjustHeight
                                                height="320px"
                                                width="320px"
                                                listType="toggle"
                                                canReorder={true}
                                                revealEllipsis={true}
                                                positionRight="0px"
                                                onReorder={newOrder => {
                                                    console.log('reorder', newOrder);
                                                    let newOrderById = {};
                                                    newOrder.forEach((item, index) => {
                                                        newOrderById[item.id] = index;
                                                    });
                                                    console.log('newOrderById', newOrderById);
                                                    this.saveColumnsOrder(newOrderById);
                                                }}
                                                onClose={() => {
                                                    this.setState({
                                                        showDisplayedCustomColumns: false
                                                    });
                                                }}
                                                items={withDropdownTitles(this.tableColumnsOrdered())}
                                                onChange={(columnId, isChecked) => {
                                                    this.handleDisplayedTableColumns(columnId, isChecked);
                                                }}
                                                renderBottomStickyButton={
                                                    <div className="flex gap-3 w-full">
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handleOpenModalManageColumns}
                                                            className="grow !m-0"
                                                        >
                                                            Manage
                                                        </Button>
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.resetTableColumns}
                                                            className="grow !m-0"
                                                        >
                                                            Reset
                                                        </Button>
                                                    </div>
                                                }
                                            />
                                        )}
                                    </Box>
                                </Flex>
                            </Box>
                        </Flex>
                    </AppPageWrapperSectionSubHeader>

                    <AppPageWrapperSectionBody style={{ margin: '0 32px', width: 'calc(100% - 64px)' }}>
                        <StudyParticipantsList
                            adminFacing
                            isLoading={this.state.study_people_loading && !this.state.study_people_loading_more}
                            auth={this.props.auth}
                            study={this.state.study}
                            study_people={this.state.study_people}
                            onClickParticipant={sp => {
                                this.handleCardClick(sp.id);
                            }}
                            p_checked={this.state.p_checked}
                            checkAllOrVisibleStatus={this.state.checkAllOrVisibleStatus}
                            onCheckParticipant={this.toggleCheckbox}
                            handleCheckAllDropdownChange={this.handleCheckAllDropdownChange}
                            theme={this.props.theme}
                            deselectAll={this.deselectAll}
                            loadMoreStudyPeople={this.loadMoreStudyPeople}
                            onChangePaginationLimit={this.onChangePaginationLimit}
                            pagination_limit={this.state.pagination_limit}
                            study_people_loading_more={this.state.study_people_loading_more}
                            sort={this.state.sort}
                            onChangeSort={sort => {
                                this.setState({ sort }, () => {
                                    this.getStudyPeople(this.state.segment);
                                });
                            }}
                            showHideColumns={this.tableColumnsOrdered()}
                            onSearchKeywordChange={this.onSearchKeywordChange}
                            onStudyPersonUpdate={studyPerson => this.updateStudyPersonInGrid(studyPerson)}
                        />
                    </AppPageWrapperSectionBody>

                    <ManageColumnsModalConnected
                        isOpen={this.state.showModalManageColumns}
                        onClose={this.handleCloseModalManageColumns}
                        study={this.state.study}
                        tableColumnsHidden={this.state.tableColumns_hidden}
                        panelPropertyIds={this.state.panelPropertyIds}
                        onSave={this.handleManageColumnsSaved}
                    />

                    <NiceModal
                        title={`Upload panelists into study`}
                        isOpen={
                            this.state.panels && this.state.panels.length > 0 && this.state.showModalParticipantImport
                        }
                        shouldCloseOnOverlayClick={false}
                        shouldCloseOnEsc={false}
                        onRequestClose={this.handleCloseModalParticipantImport}
                        style={{ content: { width: '980px' } }}
                    >
                        <UploadParticipants
                            study_id={this.state.study.id}
                            onClose={this.handleCloseModalParticipantImport}
                            onDone={() => {
                                this.handleCloseModalParticipantImport();
                            }}
                            onUpdatePanels={this.onUpdatePanels}
                            panels={this.state.panels}
                        />
                    </NiceModal>

                    <ReactModal
                        isOpen={this.state.showModalStudyParticipant}
                        shouldCloseOnOverlayClick
                        onRequestClose={this.handleCloseModalStudyParticipant}
                        style={{ content: { width: '1140px', overflow: 'inherit', height: '100%' } }}
                    >
                        {this.state.selectedStudyPerson && this.state.selectedStudyPerson.id ? (
                            <ParticipantNotes
                                parentCallback={this.modalParticipantNotesCallbackFunction}
                                study_person={this.state.selectedStudyPerson}
                                study={this.state.study}
                                auth={this.props.auth}
                                senderProfiles={this.state.sender_profiles}
                                onSearchKeywordChange={e => {
                                    this.onSearchKeywordChange(e);
                                    this.handleCloseModalStudyParticipant();
                                }}
                            />
                        ) : (
                            <Box style={{ width: '100%', height: '120px' }}>
                                <LoadingWrapper>
                                    <LoadingIndicator />
                                </LoadingWrapper>
                            </Box>
                        )}
                    </ReactModal>

                    <ReactModal
                        isOpen={this.state.showModalSendCampaign}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => this.handleCloseModalSendCampaign(true)}
                        style={{ content: { width: '100%', maxWidth: '1100px' } }}
                    >
                        {this.state.showModalSendCampaign_editMode && (
                            <Box p={4}>
                                <H1>Edit Mass Email</H1>

                                <Flex className="form-wrapper2" width="100%" flexDirection="column">
                                    <Flex sx={{ gridGap: '32px' }} my="24px">
                                        <Box flex="2">
                                            <Box className="form-label">Email Subject</Box>
                                            <Box>
                                                <Input
                                                    type="text"
                                                    name="email_custom_subject"
                                                    value={this.state.sendCampaign.subject}
                                                    onChange={e => {
                                                        this.handleModalSendCampaign_stateUpdate(
                                                            'subject',
                                                            e.target.value
                                                        );
                                                    }}
                                                    placeholder="Email Subject"
                                                />
                                            </Box>
                                        </Box>
                                    </Flex>
                                </Flex>

                                <EmailEditor
                                    type={this.state.sendCampaign.templateType}
                                    editorData={this.state.sendCampaign.content}
                                    onChange={this.onChangeEditor}
                                    allowDscoutButton
                                    allowScreenerButton
                                    onTemplate={template => this.onTemplate(template)}
                                    branding={this.state.study.branding || {}}
                                    headerActions={
                                        <MergeTagsDropdown
                                            study={this.state.study}
                                            templateType={this.state.sendCampaign.templateType}
                                        />
                                    }
                                />
                                <br />
                                <br />
                                <br />
                            </Box>
                        )}
                        {!this.state.showModalSendCampaign_editMode &&
                            (this.state.emailCampaignPreview_loading ? (
                                <Box mb={3} style={{ width: '100%', height: '120px' }}>
                                    <LoadingWrapper>
                                        <LoadingIndicator />
                                    </LoadingWrapper>
                                </Box>
                            ) : (
                                <Box p={4} background="#f7f7f7">
                                    {this.state.emailCampaignPreview ? (
                                        this.renderEmailCampaignPreview(this.state.emailCampaignPreview)
                                    ) : (
                                        <div>Email preview did not load. Likely the candidate chose to "Opt Out".</div>
                                    )}
                                </Box>
                            ))}

                        <Flex
                            justifyContent="space-between"
                            px={4}
                            py={3}
                            style={{
                                position: 'sticky',
                                bottom: 0,
                                background: '#f7f7f7',
                                borderTop: '1px solid #eee',
                                zIndex: 100
                            }}
                        >
                            {!this.state.showModalSendCampaign_editMode && (
                                <Flex flexDirection="column" sx={{ width: '100%', textAlign: 'right' }}>
                                    <input type="file" id="email_attachment_upload" hidden />

                                    {(this.state.email_attachments.length > 0 ||
                                        this.state.email_attachment_isUploading == true) && (
                                        <Box mb={3} sx={{ width: '100%' }}>
                                            <Box fontSize={1} sx={{ float: 'right', width: '100%' }}>
                                                {this.state.email_attachments.map((a, index) => {
                                                    return (
                                                        <Flex className="fs-13" justifyContent="end">
                                                            <Flex
                                                                className="va-top"
                                                                style={{ marginTop: '8px', maxWidth: '75%' }}
                                                            >
                                                                <Box className="ellipsis">{a.filename}</Box>
                                                                <Box ml={1} style={{ color: '#999', flexShrink: 0 }}>
                                                                    ({helpers.humanFileSize(a.filesize)})
                                                                </Box>
                                                            </Flex>
                                                            <Box sx={{ flexShrink: 0 }}>
                                                                <Button
                                                                    type="button"
                                                                    variant="transparent-icon"
                                                                    ml={2}
                                                                    onClick={() => {
                                                                        let { email_attachments } = this.state;
                                                                        email_attachments.splice(index, 1);
                                                                        this.setState({ email_attachments });
                                                                    }}
                                                                >
                                                                    <FiXCircle />
                                                                </Button>
                                                            </Box>
                                                        </Flex>
                                                    );
                                                })}
                                            </Box>
                                            {this.state.email_attachment_isUploading == true && (
                                                <Box mr={2}>
                                                    <LoadingIndicator relativePosition={true} />
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    <Box sx={{ width: '100%', textAlign: 'right' }}>
                                        <Button
                                            variant="secondary-gray"
                                            mr={3}
                                            type="button"
                                            onClick={() => this.handleCloseModalSendCampaign(true)}
                                        >
                                            Cancel
                                        </Button>

                                        <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                            <Button
                                                variant="secondary-gray"
                                                mr={3}
                                                onClick={() => {
                                                    this.setState({ showEmailCampaignMoreDropdown: true });
                                                }}
                                            >
                                                More <FiChevronDown style={{ marginRight: 0 }} />
                                            </Button>
                                            {this.state.showEmailCampaignMoreDropdown == true && (
                                                <NiceDropdown
                                                    positionTop="auto"
                                                    positionBottom={'38px'}
                                                    positionLeft={'-1px'}
                                                    onClose={() => {
                                                        this.setState({ showEmailCampaignMoreDropdown: false });
                                                    }}
                                                    items={mass_email_actions}
                                                />
                                            )}
                                        </Box>
                                        <Button
                                            type="submit"
                                            sx={{ marginRight: 0 }}
                                            onClick={() => {
                                                const email_action = 'send';
                                                this.handleModalSendCampaign_review(email_action);
                                            }}
                                            disabled={
                                                this.state.isSendingCampaign ||
                                                this.isEmailSendingDisabled() ||
                                                this.state.study_people_loading
                                            }
                                        >
                                            <FiSend /> {this.generateSendToNumberPeople()}
                                        </Button>
                                    </Box>
                                </Flex>
                            )}

                            {this.state.showModalSendCampaign_editMode && (
                                <div style={{ textAlign: 'right', width: '100%' }}>
                                    <Button
                                        type="button"
                                        variant="secondary-gray"
                                        mr={3}
                                        onClick={() => {
                                            this.setState({ showModalSendCampaign_editMode: false });
                                        }}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        type="submit"
                                        sx={{ marginRight: 0 }}
                                        onClick={() => {
                                            const email_action = 'preview';
                                            this.handleModalSendCampaign_review(email_action);
                                            this.setState({ showModalSendCampaign_editMode: false });
                                        }}
                                    >
                                        <FiSave /> Save and continue
                                    </Button>
                                </div>
                            )}
                        </Flex>
                    </ReactModal>

                    <NiceModal
                        isOpen={this.state.showModalScheduleSend}
                        onRequestClose={() => this.setState({ showModalScheduleSend: false })}
                        style={{ content: { width: 'auto', maxWidth: '1100px' } }}
                        title="Schedule to send"
                    >
                        <Flex>
                            <Box>
                                <DatePicker
                                    inline
                                    className={`theme-input`}
                                    style={{ width: '100%' }}
                                    showTimeInput
                                    onChange={date => {
                                        let { sendCampaign } = this.state;
                                        sendCampaign.send_when = date;
                                        this.setState({ sendCampaign });
                                    }}
                                    selected={this.state.sendCampaign.send_when}
                                />
                            </Box>
                        </Flex>
                        <Box className="modal-actions">
                            <Button
                                type="button"
                                variant="secondary-gray"
                                mr={3}
                                onClick={() => {
                                    let { sendCampaign } = this.state;
                                    sendCampaign.send_when = null;
                                    this.setState({ sendCampaign });

                                    this.setState({ showModalScheduleSend: false });
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="submit"
                                variant="primary"
                                sx={{ marginRight: 0 }}
                                disabled={
                                    this.state.isSendingCampaign == true ||
                                    this.isEmailSendingDisabled() ||
                                    this.state.study_people_loading
                                }
                                onClick={() => {
                                    const email_action = 'send';
                                    this.handleModalSendCampaign_review(email_action);
                                }}
                            >
                                <FiCalendar /> {this.state.isSendingCampaign == true ? 'Scheduling...' : 'Schedule'}
                            </Button>
                        </Box>
                    </NiceModal>

                    {this.state.study.incentive != null && (
                        <PaymentModal
                            title="Bulk Pay"
                            isOpen={this.state.showModalBulkPay}
                            auth={this.props.auth}
                            onClose={() => this.setState({ showModalBulkPay: false })}
                            onPay={data => this.onBulkPayConfirm(data)}
                            payees={this.state.bulk_pay_people}
                            study={this.state.study}
                            defaultValues={{
                                amount: this.state.study.incentive
                            }}
                        />
                    )}

                    <DeleteStudyPeopleModal
                        isOpen={this.state.deleteStudyPeopleModal.isOpen}
                        onClose={this.closeRemoveStudyPeopleModal}
                        onConfirm={this.confirmRemoveStudyPeople}
                        isSubmitting={this.state.deleteStudyPeopleModal.isSubmitting}
                        requiresForce={this.state.deleteStudyPeopleModal.requiresForce}
                        participantCount={
                            this.state.deleteStudyPeopleModal.request
                                ? this.state.deleteStudyPeopleModal.request.participantCount
                                : 0
                        }
                    />

                    <NiceModal
                        isOpen={this.state.showModalBulkEditSp}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => this.setState({ showModalBulkEditSp: false })}
                        title="Bulk edit respondents"
                        overflow="visible"
                    >
                        <form onSubmit={this.onProcessBulkEdit}>
                            <Box>
                                <Label>Field to update</Label>

                                <Box sx={{ position: 'relative' }}>
                                    <Button
                                        type="button"
                                        variant="secondary-gray"
                                        onClick={() => this.setState({ showBulkEditFieldsDropdown: true })}
                                    >
                                        {this.state.bulk_edit_field.id
                                            ? this.state.bulk_edit_field.title
                                            : 'Select a field'}{' '}
                                        <FiChevronDown style={{ marginRight: 0 }} />
                                    </Button>
                                    {this.state.showBulkEditFieldsDropdown && (
                                        <NiceDropdown
                                            showSearch
                                            onClose={() => this.setState({ showBulkEditFieldsDropdown: false })}
                                            items={this.getBulkEditableFields()}
                                            onChange={id => {
                                                const chosen_bulk_edit_field = this.getBulkEditableFields().find(
                                                    ac => ac.id == id
                                                );
                                                this.setState({ bulk_edit_field: chosen_bulk_edit_field });
                                            }}
                                        />
                                    )}
                                </Box>

                                {this.renderBulkEditValueChanger()}
                            </Box>
                            <Box className="modal-actions">
                                <Button
                                    type="button"
                                    variant="secondary-gray"
                                    mr={3}
                                    onClick={() => {
                                        this.setState({
                                            showModalBulkEditSp: false
                                        });
                                    }}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    sx={{ marginRight: 0 }}
                                    disabled={!this.state.bulk_edit_field.id}
                                >
                                    Update respondents
                                </Button>
                            </Box>
                        </form>
                    </NiceModal>

                    <DscoutInviteModal
                        study={this.state.study}
                        isOpen={this.state.showModalDscoutMissions}
                        onClose={() => this.setState({ showModalDscoutMissions: false })}
                        onSendEmail={this.clickSendEmail}
                    />

                    <ReactModal
                        isOpen={this.state.showModalEditTabs}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => this.setState({ showModalEditTabs: false })}
                    >
                        <Box m={4} fontSize={1}>
                            <H1 style={{ marginBottom: '16px' }}>Edit Tabs</H1>
                            <Flex mb={3} sx={{ gridGap: 3 }}>
                                <Box width={7 / 10}>Title</Box>
                                <Box width={2 / 10}>Order</Box>
                                <Box width={1 / 10}>Delete</Box>
                            </Flex>
                            {this.state.study.study_states &&
                                this.state.study.study_states
                                    .sort((a, b) => a.order - b.order)
                                    .map(ss => {
                                        const num_tot_ss = this.state.study.study_states.length;
                                        let order_options = [];
                                        for (let i = 1; i <= num_tot_ss; i++) {
                                            order_options.push(i);
                                        }

                                        return (
                                            <Flex mb={3} sx={{ gridGap: 3 }}>
                                                <Box width={7 / 10}>
                                                    <Input
                                                        type="text"
                                                        mr={2}
                                                        value={ss.title}
                                                        name="tab_title"
                                                        onChange={e => this.onTabChange(e, ss)}
                                                    />
                                                </Box>
                                                <Box width={2 / 10}>
                                                    <Select
                                                        value={ss.order}
                                                        name="tab_order"
                                                        onChange={e => this.onTabChange(e, ss)}
                                                    >
                                                        {order_options.map(oo => {
                                                            return <option value={oo}>{oo}</option>;
                                                        })}
                                                    </Select>
                                                </Box>
                                                <Box width={1 / 10}>
                                                    {ss.type != 'candidates' && (
                                                        <Button
                                                            type="button"
                                                            variant="tertiary-icon"
                                                            onClick={e => this.onTabDelete(ss)}
                                                        >
                                                            <FiMinusCircle />
                                                        </Button>
                                                    )}
                                                </Box>
                                            </Flex>
                                        );
                                    })}
                        </Box>
                    </ReactModal>

                    <NiceModal
                        isOpen={this.state.showModalExportCsv}
                        shouldCloseOnOverlayClick
                        onRequestClose={e => {
                            this.setState({ showModalExportCsv: false });
                        }}
                        title="Which columns would you like to export?"
                        style={{ content: { width: '600px' } }}
                    >
                        <Box>
                            <Box mb={4}>
                                {this.state.study.screeners.map(screener => {
                                    let screener_q_list = [];
                                    screener_q_list.push(
                                        <Box mb={'4px'}>
                                            <Label className="bold text-primary" mb={0}>
                                                Screener Title: {screener.title}
                                            </Label>
                                            <Button
                                                variant="link"
                                                type="button"
                                                className="bold"
                                                mr={3}
                                                onClick={e => {
                                                    // remove all checkboxes here from the exclude
                                                    let { export_csv_checkboxes_exclude } = this.state;
                                                    const els = document.getElementsByClassName(
                                                        `screener_id_question_${screener.id}`
                                                    );
                                                    Array.prototype.forEach.call(els, function(el) {
                                                        delete export_csv_checkboxes_exclude[
                                                            el.dataset.question_field_name
                                                        ];
                                                    });
                                                    this.setState({ export_csv_checkboxes_exclude });
                                                    this.setCachedCsvExportScreenerColumns(
                                                        export_csv_checkboxes_exclude
                                                    );
                                                }}
                                            >
                                                Select All
                                            </Button>
                                            <Button
                                                variant="link"
                                                type="button"
                                                className="red bold"
                                                onClick={e => {
                                                    // add all checkboxes here to the exclude
                                                    let { export_csv_checkboxes_exclude } = this.state;
                                                    const els = document.getElementsByClassName(
                                                        `screener_id_question_${screener.id}`
                                                    );
                                                    Array.prototype.forEach.call(els, function(el) {
                                                        export_csv_checkboxes_exclude[
                                                            el.dataset.question_field_name
                                                        ] = true;
                                                    });
                                                    this.setState({ export_csv_checkboxes_exclude });
                                                    this.setCachedCsvExportScreenerColumns(
                                                        export_csv_checkboxes_exclude
                                                    );
                                                }}
                                            >
                                                Deselect All
                                            </Button>
                                        </Box>
                                    );

                                    helpersStudy.getScreenerQuestions(screener).map(q => {
                                        if (!q.static) {
                                            screener_q_list.push(
                                                <Box mb={1} style={{ display: 'block' }}>
                                                    <Label
                                                        className="for-checkbox ellipsis"
                                                        style={{ display: 'block' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className={`screener_id_question_${screener.id}`}
                                                            name="export_csv_checkboxes_exclude"
                                                            data-question_field_name={q.field_name}
                                                            style={{ margin: '4px 2px 0 0' }}
                                                            checked={
                                                                !this.state.export_csv_checkboxes_exclude.hasOwnProperty(
                                                                    q.field_name
                                                                )
                                                            }
                                                            onClick={e => {
                                                                let { export_csv_checkboxes_exclude } = this.state;
                                                                if (e.target.checked) {
                                                                    delete export_csv_checkboxes_exclude[q.field_name];
                                                                } else {
                                                                    export_csv_checkboxes_exclude[q.field_name] = true;
                                                                }
                                                                this.setState({ export_csv_checkboxes_exclude });
                                                                this.setCachedCsvExportScreenerColumns(
                                                                    export_csv_checkboxes_exclude
                                                                );
                                                            }}
                                                        />{' '}
                                                        {helpers.removeHtml(q.label)}
                                                    </Label>
                                                </Box>
                                            );
                                        }
                                    });

                                    return (
                                        <Box>
                                            {screener_q_list}

                                            <br />
                                            <hr />
                                            <br />
                                        </Box>
                                    );
                                })}
                                <Box>
                                    <Box mb={'4px'}>
                                        <Label className="bold text-primary" mb={0}>
                                            Panelist Properties{' '}
                                            {helpers.newFeatureTag(moment('10-28-2021', 'MM-DD-YYYY'), {
                                                margin: '1px 0 0 8px'
                                            })}
                                        </Label>
                                        <Button
                                            variant="link"
                                            type="button"
                                            className="bold"
                                            mr={3}
                                            onClick={e => {
                                                // remove all checkboxes here from the exclude
                                                let { export_csv_custom_columns_include } = this.state;
                                                const els = document.getElementsByClassName(
                                                    `csv_export_custom_columns`
                                                );
                                                Array.prototype.forEach.call(els, function(el) {
                                                    export_csv_custom_columns_include[
                                                        el.dataset.custom_column_id
                                                    ] = true;
                                                });
                                                this.setState({ export_csv_custom_columns_include });
                                                this.setCachedCsvExportPanelColumns(export_csv_custom_columns_include);
                                            }}
                                        >
                                            Select All
                                        </Button>
                                        <Button
                                            variant="link"
                                            type="button"
                                            className="red bold"
                                            onClick={e => {
                                                // add all checkboxes here to the exclude
                                                let { export_csv_custom_columns_include } = this.state;
                                                const els = document.getElementsByClassName(
                                                    `csv_export_custom_columns`
                                                );
                                                Array.prototype.forEach.call(els, function(el) {
                                                    delete export_csv_custom_columns_include[
                                                        el.dataset.custom_column_id
                                                    ];
                                                });
                                                this.setState({ export_csv_custom_columns_include });
                                                this.setCachedCsvExportPanelColumns(export_csv_custom_columns_include);
                                            }}
                                        >
                                            Deselect All
                                        </Button>
                                    </Box>
                                    <Box>
                                        {this.state.panel_columns.map(pc => {
                                            return (
                                                <Box mb={1} style={{ display: 'block' }}>
                                                    <Label
                                                        className="for-checkbox ellipsis"
                                                        style={{ display: 'block' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className={`csv_export_custom_columns`}
                                                            name="export_csv_custom_columns_include"
                                                            data-custom_column_id={pc.id}
                                                            style={{ margin: '4px 2px 0 0' }}
                                                            checked={this.state.export_csv_custom_columns_include.hasOwnProperty(
                                                                pc.id
                                                            )}
                                                            onClick={e => {
                                                                let { export_csv_custom_columns_include } = this.state;
                                                                if (e.target.checked) {
                                                                    export_csv_custom_columns_include[pc.id] = true;
                                                                } else {
                                                                    delete export_csv_custom_columns_include[pc.id];
                                                                }
                                                                console.log(export_csv_custom_columns_include);
                                                                this.setState({ export_csv_custom_columns_include });
                                                                this.setCachedCsvExportPanelColumns(
                                                                    export_csv_custom_columns_include
                                                                );
                                                            }}
                                                        />{' '}
                                                        {pc.title}
                                                    </Label>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Flex className="modal-actions modal-actions-sticky" sx={{ justifyContent: 'space-between' }}>
                            <Box>{this.renderBulkDownload()}</Box>
                            <Box>
                                <Button
                                    type="button"
                                    variant="secondary-gray"
                                    mr={3}
                                    onClick={() => {
                                        this.setState({ showModalExportCsv: false });
                                    }}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    sx={{ marginRight: 0 }}
                                    onClick={() => {
                                        const export_csv = true;
                                        this.getStudyPeople(this.state.segment, 1, export_csv);
                                        this.setState({ showModalExportCsv: false });
                                    }}
                                >
                                    Export CSV
                                </Button>
                            </Box>
                        </Flex>
                    </NiceModal>

                    <NiceModal
                        isOpen={this.state.showModalSMSMessage}
                        shouldCloseOnOverlayClick
                        onRequestClose={this.handleCloseModalSMSMessage}
                        title="Send SMS"
                    >
                        <form
                            onSubmit={e => {
                                e.preventDefault();
                                this.handleModalSendSms('send');
                            }}
                        >
                            <Box>
                                <MergeTagsDropdown
                                    study={this.state.study}
                                    templateType={this.state.sendCampaign.templateType}
                                />
                                <Label mt={3}>Message</Label>
                                <TextAreaAutosize
                                    name="sms-campaign-content"
                                    value={this.state.smsCampaign_content}
                                    onChange={e => {
                                        this.setState({ smsCampaign_content: e.target.value });
                                    }}
                                    style={{ width: '100%', height: '200px' }}
                                    className="theme-input"
                                    minRows={4}
                                    autoFocus
                                ></TextAreaAutosize>
                            </Box>
                            <Box className="modal-actions">
                                <Button
                                    type="button"
                                    variant="secondary-gray"
                                    mr={3}
                                    onClick={this.handleCloseModalSMSMessage}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    mr={0}
                                    disabled={this.state.isSendingSmsCampaign || this.state.study_people_loading}
                                >
                                    <FiSend /> {this.generateSendToNumberPeople()}
                                </Button>
                            </Box>
                        </form>
                    </NiceModal>

                    <SelectModal
                        type="study"
                        title={`Assign to user`}
                        items={select_modal_assign_users_list}
                        isOpen={this.state.showModalAssignUser}
                        isLoading={false}
                        onRequestClose={() => {
                            this.setState({ showModalAssignUser: false });
                        }}
                        onSelect={this.onSubmitAssignUserToPerson.bind(this)}
                    />

                    <ReactModal
                        isOpen={this.state.showModalDataViz}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => {
                            this.setState({ showModalDataViz: false });
                        }}
                    >
                        <Box m={4}>
                            <DataViz study_id={this.props.match.params.id} screener_id={this.state.datavizScreenerId} />
                        </Box>
                    </ReactModal>

                    <ReactModal
                        isOpen={this.state.showModalEmailCampaignSuccess}
                        shouldCloseOnOverlayClick
                        onRequestClose={() => {
                            this.setState({ showModalEmailCampaignSuccess: false });
                        }}
                        style={{ content: { maxWidth: '400px', overflow: 'hidden' } }}
                    >
                        <Box pt={4} pb={2} sx={{ textAlign: 'center' }}>
                            <RichIconBackground
                                color={this.state.showModalEmailCampaignSuccess_scheduled ? 'yellow' : 'green'}
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    minWidth: '48px',
                                    minHeight: '48px',
                                    fontSize: '22px'
                                }}
                            >
                                {this.state.showModalEmailCampaignSuccess_scheduled ? <FiCalendar /> : <FiSend />}
                            </RichIconBackground>
                        </Box>

                        <Box m={4} mt={0} style={{ textAlign: 'center' }}>
                            <Box mt={0} style={{ fontSize: '24px', fontWeight: 500 }}>
                                {this.state.showModalEmailCampaignSuccess_scheduled
                                    ? 'Campaign scheduled.'
                                    : 'Campaign sent!'}
                            </Box>
                            <Box fontSize={1} sx={{ color: '#606E85', m: '8px 0 32px 0' }}>
                                View past and scheduled campaigns anytime under Manage Campaigns.
                            </Box>
                            {this.state.showModalEmailCampaignSuccess_message && (
                                <Box mb={4}>
                                    {this.state.showModalEmailCampaignSuccess_showlink == true ? (
                                        this.state.showModalEmailCampaignSuccess_message
                                    ) : (
                                        <Button
                                            type="button"
                                            variant="tertiary"
                                            mr={0}
                                            mt={3}
                                            onClick={e => {
                                                this.setState({ showModalEmailCampaignSuccess_showlink: true });
                                                analytics.track('study-mass_email-getSocialLink');
                                            }}
                                        >
                                            Get e-mail link
                                        </Button>
                                    )}
                                </Box>
                            )}
                            <Flex style={{ gap: '12px', justifyContent: 'center' }}>
                                <Link to={`/studies/${this.state.study.id}/emails`}>
                                    <Button type="button" variant="secondary-gray" height="40px" px={3}>
                                        <FiMail style={{ marginRight: '6px' }} />
                                        Manage Campaigns
                                    </Button>
                                </Link>
                                <Button
                                    type="button"
                                    variant="primary"
                                    height="40px"
                                    px={4}
                                    onClick={() => {
                                        this.setState({ showModalEmailCampaignSuccess: false });
                                    }}
                                >
                                    Done
                                </Button>
                            </Flex>
                        </Box>
                    </ReactModal>

                    {this.state.study && this.state.screenerFilters && this.state.showScreenerFilters && (
                        <SideOverlay
                            onClose={() => {
                                this.setState({ showScreenerFilters: false });
                            }}
                        >
                            <StudyFilters
                                filtersOnStudyPage={true}
                                study={this.state.study}
                                panel_columns={this.state.panel_columns}
                                users={this.state.account_users.map(au => au.user)}
                                availability={this.state.study_availability_array}
                                segment={this.state.segment}
                                screenerFilters={this.state.screenerFilters}
                                onScreenerFiltersChange={sf => {
                                    this.setState({ screenerFilters: sf }, () => {
                                        // Invalidate any prior "select all / custom count" selection — those
                                        // were against the previous filter population, so keeping them would
                                        // let the user submit a campaign whose recipient set the server
                                        // resolves from the NEW filters at request time (PFOX-1284).
                                        this.deselectAll();
                                        this.getStudyPeople(this.state.segment);
                                    });
                                }}
                                onScreenerFiltersSave={sf => {
                                    this.updateStudyState(this.state.segment, sf);
                                }}
                                onScreenerFiltersSaveAsNew={sf => {
                                    this.onBoardColumnNew(sf);
                                }}
                                onClose={() => {}}
                                onScreenerFiltersDelete={() => {
                                    this.onTabDelete(this.state.segment);
                                }}
                                onScreenerFiltersRename={() => {
                                    const ss_id = this.state.segment;

                                    const study_state = this.state.study.study_states.find(ss => ss.id == ss_id);
                                    if (study_state) {
                                        const new_tab_title = prompt('What is the name?', study_state.title);
                                        if (new_tab_title) {
                                            this.onTabChange(
                                                { target: { name: 'tab_title', value: new_tab_title } },
                                                study_state
                                            );
                                        }
                                    }
                                }}
                            />
                        </SideOverlay>
                    )}
                    <ReactCanvasConfetti
                        refConfetti={this.getInstance}
                        style={{
                            position: 'fixed',
                            pointerEvents: 'none',
                            width: '100%',
                            height: '100%',
                            top: 0,
                            left: 0,
                            zIndex: 99999
                        }}
                    />
                </AppPageWrapper>
                <ShareStudyPeopleModal
                    sourceStudyId={this.state.study.id}
                    isOpen={!!this.state.shareStudyPeopleFilterObject}
                    onClose={() => this.setState({ shareStudyPeopleFilterObject: null })}
                    filterObject={this.state.shareStudyPeopleFilterObject}
                    title={this.state.shareStudyPeopleTitle}
                />
                {this.state.isRecipientsPreviewModalOpen && (
                    <ReviewRecipientsModal
                        checkAllOrVisibleStatus={this.state.checkAllOrVisibleStatus}
                        isOpen
                        onClose={() => this.setState({ isRecipientsPreviewModalOpen: false })}
                        studyId={this.state.study.id}
                        checkedPeople={this.state.p_checked}
                        filters={{
                            searchKeyword: this.state.search_keyword,
                            filters: this.state.screenerFilters
                        }}
                    />
                )}
            </Flex>
        );
    }
}

export default withRouter(withTheme(withToastManager(withToastHelper(StudyPage))));
